import { Component, OnInit, OnChanges, SimpleChanges, Input, ViewChild, ElementRef } from '@angular/core';
import { SellerApiService } from '../../service/seller-api.service';
import { KitchenModal } from '../kitchenmodal';
// jQuery Sign $
declare let $: any;

@Component({
  selector: 'app-kitchen',
  templateUrl: './kitchen.component.html',
  styleUrls: ['./kitchen.component.scss']
})
export class KitchenComponent implements OnInit, OnChanges {

  @Input() projectId: number;
  @Input() currentUserId: number;
  @Input() currentSellerId: number;
  @Input() brief: boolean;
  @Input() details: boolean;
  @Input() safetyAttach: boolean;
  @Input() browseAttach: boolean;
  @Input() isedit: boolean;
  @Input() displaycomname: string;
  kitchen: KitchenModal;
  isbreif: boolean;
  isDetails: boolean;
  isSafetyAttach: boolean;
  isBrowseAttach: boolean;
  isEditable: boolean;
  isVisibleEdit: boolean;
  displaycomponent: string;
  isuploadImages: boolean;
  uploaded_links: Array<any> = [];
  @ViewChild('kitchecnscopecom') kitchecnscopecom;
  @ViewChild('kitchendetailscom') kitchendetailscom;
  @ViewChild('kitchensafetyboxbrowse') kitchensafetyboxbrowse;
  @ViewChild('saveConfirmationModal') saveConfirmationModal: ElementRef;

  constructor(private sellerService: SellerApiService) {
    this.kitchen = new KitchenModal();
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    this.displaycomponent = this.displaycomname;
    this.isDetails = this.details;
    this.isbreif = this.brief;
    this.isSafetyAttach = this.safetyAttach;
    this.isBrowseAttach = this.browseAttach;
    this.isVisibleEdit = this.isedit;
    this.isEditable = false;
    if (this.projectId != null && this.currentUserId != null) {
      this.getServiceRequestByprojectId(this.projectId, this.currentUserId);
    }

  }
  // Editable Option Enable
  callEditableOption() {
    this.isEditable = true;
    this.isuploadImages = true;
  }

  // Call the Modal to open
  callModaltoOpen() {
    $(this.saveConfirmationModal.nativeElement).modal('show');
  }

  // Call Save Button
  callSave() {
    if (this.currentSellerId != null) {
      this.kitchen.seller_id = this.currentSellerId;
      this.kitchen.project_id = this.projectId;
      // tslint:disable-next-line:prefer-const
      let obj1 = Object.assign(this.kitchen, this.kitchecnscopecom.kitchen);
      // tslint:disable-next-line:prefer-const
      let finalObj = Object.assign(obj1, this.kitchendetailscom.kitchen);
      finalObj.kitchen_details_do_you_want_to_move = this.kitchendetailscom.selectedkitchenrow.map(function(item) {
        return item['name'];
      }).toString();
      this.kitchen = finalObj;
      this.sellerService.update_serviceRequestBySeller(finalObj, this.kitchensafetyboxbrowse.scope_upload_links).subscribe(res => {
        $(this.saveConfirmationModal.nativeElement).modal('hide');
        this.isEditable = false;
        this.isuploadImages = false;
      }, err => {
        console.log(err);
      });
    }
  }

  calltoremoveModal() {
    $(this.saveConfirmationModal.nativeElement).modal('hide');
   // this.isVisibleEdit = false;
  }

   // Call Cancel Button
   callCancelOption() {
    this.isEditable = false;
    this.isuploadImages = false;
  }


  // Get the Project Information using projectID and Seller User Id. (Categories Scope and Details )
  getServiceRequestByprojectId(project_id, user_id) {
    this.kitchen = new KitchenModal();
    this.sellerService.getServiceRequestDetailsByProjectId(project_id, user_id).subscribe(res => {
      if (res != null) {
        this.kitchen = this.toObject(res);
        this.uploaded_links = this.kitchen.scope_upload_links;
      }
    }, err => {
      console.log(err);
    });
  }

  // to convert to Kitchen Modal Here
  toObject(arr) {
    // tslint:disable-next-line:prefer-const
    let kitchn = new KitchenModal();
    arr.forEach((item, index) => {
      if (item.answer === 'False') {
        kitchn[item.question_name] = false;
      } else if (item.answer === 'True') {
        kitchn[item.question_name] = true;
      } else {
        kitchn[item.question_name] = item.answer;
      }
    });

    // for (let i = 0; i < arr.length; ++i) {
    //   if (Object.values(arr[i])[0] === 'False') {
    //     kitchn[Object.keys(arr[i])[0]] = false;
    //   } else if (Object.values(arr[i])[0] === 'True') {
    //     kitchn[Object.keys(arr[i])[0]] = true;
    //   } else {
    //     kitchn[Object.keys(arr[i])[0]] = Object.values(arr[i])[0];
    //   }
    // }
    return kitchn;
  }

  getgeneratedpdf() {
    // tslint:disable-next-line:prefer-const <h4>Brief</h4>
    let scopeDetailsPdf = '      <!-- section Last <div style="page-break-before:always">  -->' +
      '      <div class="container">' +
      // '        <div class="row mt-5">' +
      // ' </div>' +
      '     <div class="row"><div class="table-responsive">' +
      '            <table class="table table-bordered">' +
      '              <tbody>' +
      '                <tr>' +
      '                  <td>Projektnamn  <br/><span class="text-secondary">' +
      this.kitchen.project_name + '</span></td>' +
      // tslint:disable-next-line:max-line-length
      '                  <td>Kategori <br/> <span class="text-secondary">' + this.kitchecnscopecom.service_category_name + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      '                  <td>Vilken typ av projekt gäller det? <br/><span class="text-secondary">'
      + this.getFreetextValueDisplay(this.kitchen.kitchen_scope_kitchen_project_type) + '</span></td>' +
      '                  <td>' +
      ' ' + '</td>' +
      '                </tr>' +
      '                <tr>' +
      '                  <td>Välj typ av kök? <br/><span class="text-secondary">'
      + this.kitchecnscopecom.get_kitchen_scope_is_module(this.kitchen.kitchen_scope_is_module) + '</span></td>' +
      '                  <td>' + '' + '<br/><span class="text-secondary">' +
      this.getFreetextValueDisplay(this.kitchecnscopecom.get_kitchen_scope_module_type(this.kitchen.kitchen_scope_module_type))
      + '</span></td>' +
      '                </tr>' +

      '                <tr>' +
      // tslint:disable-next-line:max-line-length
      '                  <td colspan="2">Beskriv arbetet som ska utföras <br/><span class="text-secondary">' + this.kitchen.scope_work_description + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      // tslint:disable-next-line:max-line-length
      '                  <td>Ange projektbudget <br/><span class="text-secondary">' + this.getFreetextValueDisplay(this.kitchecnscopecom.get_scope_project_budget(this.kitchen.scope_project_budget)) + '</span></td>' +
      '                  <td>Vad ska inkluderas i prisförlaget? <br/><span class="text-secondary">'
      + this.kitchecnscopecom.get_scope_price_offer(this.kitchen.scope_price_offer) + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      // tslint:disable-next-line:max-line-length
      '                  <td colspan="2">Gatuadress <br/><span class="text-secondary">' + this.kitchen.scope_street_name + '</span></td>' +
      '                </tr>' +
      '              </tbody>' +
      '            </table>' +
      '          </div>' +
      '    </div>' +
      //  work bread down <h4>Work Break Down</h4>
      // '        <div class="row mt-5">' +
      // '  </div>' +
      '     <div class="row"><div class="table-responsive">' +
      '            <table class="table table-bordered">' +
      '              <tbody>' +
      '                <tr>' +
      '                  <td>Ungefärlig golvyta i kvm  <br/><span class="text-secondary">' +
      this.getFreetextValueDisplay(this.kitchen.kitchen_details_floor_area) + '</span></td>' +
      // tslint:disable-next-line:max-line-length
      '                  <td>Finns lokal avstängning av vatten/vvs? <br/> <span class="text-secondary">' +
      this.getFreetextValueDisplay(this.kitchendetailscom.kitchen_details_is_there_a_local_shutdown_of_water_plumbing) + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      '                  <td>Ungefärlig takhöjd i cm <br/><span class="text-secondary">'
      + this.getFreetextValueDisplay(this.kitchen.kitchen_details_ceiling_height) + '</span></td>' +
      '                  <td>' + 'Finns golvvärme?' + '<br/><span class="text-secondary">' +
      this.getFreetextValueDisplay(this.kitchendetailscom.kitchen_details_is_floor_heating_available) + '</span></td>' +
      '                </tr>' +

      '                <tr>' +
      // tslint:disable-next-line:max-line-length
      '                  <td colspan="2">Vill du flytta något utav följande från dess nuvarande position <br/><span class="text-secondary">'
      + this.getFreetextValueDisplay(this.kitchen.kitchen_details_do_you_want_to_move) + '</span></td>' +
      '                </tr>' +

      '              </tbody>' +
      '            </table>' +
      '          </div>' +
      '    </div>' +
      //  Question set start <h6>Choose what should be included in the work</h6>
      // '        <div class="row mt-5">' +
      // '          </div>' +
      '     <div class="row"><div class="table-responsive">' +
      '            <table class="table table-bordered">' +
      '              <tbody>' +
      this.generatehtmlForFirstQuestion() +
      this.generatehtmlForSecondQuestion() +
      this.generatehtmlForThirdQuestion() +
      this.generatehtmlForFourthQuestion() +
      this.generatehtmlForFivethQuestion() +
      this.generatehtmlForSixthQuestion() +
      this.generatehtmlForSeventhQuestion() +
      this.generatehtmlForEighthQuestion() +
      this.generatehtmlForNinethQuestion() +
      this.generatehtmlForTenthQuestion() +
      this.generatehtmlForEleventhQuestion() +

      '              </tbody>' +
      '            </table>' +
      '          </div>' +
      '    </div>' +



      '        </div>';

    // console.log(scopeDetailsPdf);
    return scopeDetailsPdf;
  }

  getCheckBoxTernary(value) {
    if (value) {
      return 'checked';
    } else {
      return '';
    }
  }
  getFreetextValueDisplay(value) {
    if (value != null && value !== undefined) {
      return value;
    } else {
      return '';
    }
  }

  //#region  First Question Set
  generatehtmlForFirstQuestion() {
    // tslint:disable-next-line:prefer-const
    let firstquestion = '';
    if (this.kitchen.kitchen_details_cw_is_base_cabinets) {
      firstquestion = '<div class="card-body">' +
        '                  <div class="row">' +
        '                    <div class="col ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_cw_is_base_cabinets" ' +
        '                          id="kitchen_details_cw_is_base_cabinets"' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_cw_is_base_cabinets) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_cw_is_base_cabinets">' +
        '                          Bänkskåp' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                        <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_cw_cabinets_qty) + '</span>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_cw_is_handle" ' +
        '                          id="kitchen_details_cw_is_handle"' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_cw_is_handle) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_cw_is_handle">' +
        '                          Handtag' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_cw_handle_qty) + '</span>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_cw_is_shelves" ' +
        '                          id="kitchen_details_cw_is_shelves"' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_cw_is_shelves) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_cw_is_shelves">' +
        '                          Hyllor' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_cw_shelves_qty) + '</span>' +
        '' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_cw_is_high_cabinets" value="true" ' +
        '                          id="kitchen_details_cw_is_high_cabinets"' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_cw_is_high_cabinets) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_cw_is_high_cabinets">' +
        '                          Högskåp' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_cw_high_cabinets_qty) + '</span>' +
        '                      </div>' +
        '' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_cw_is_corner_cabinet" value="true" ' +
        '                          id="kitchen_details_cw_is_corner_cabinet" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_cw_is_corner_cabinet) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_cw_is_corner_cabinet">' +
        '                          Hörnskåp' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_cw_corner_cabinet_qty) + '</span>' +
        '                      </div>' +
        '' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_cw_is_commode" ' +
        '                          id="kitchen_details_cw_is_commode"' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_cw_is_commode) + ' >' +
        '                        <label class="accordian-checkbox" for="kitchen_details_cw_is_commode">' +
        '                          Kommod' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_cw_commode_qty) + '</span>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_cw_is_kitchen_island" value="true" ' +
        '                          id="kitchen_details_cw_is_kitchen_island" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_cw_is_kitchen_island) + ' >' +
        '                        <label class="accordian-checkbox" for="kitchen_details_cw_is_kitchen_island">' +
        '                          Köksö' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_cw_kitchen_island_qty) + '</span>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_cw_is_gaps" value="true" ' +
        '                          id="kitchen_details_cw_is_gaps" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_cw_is_gaps) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_cw_is_gaps">' +
        '                          Luckor' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_cw_gaps_qty) + '</span>' +
        '                      </div>' +
        '                    </div>' +
        '                    <div class="col">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_cw_is_boxes" ' +
        '                          id="kitchen_details_cw_is_boxes"' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_cw_is_boxes) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_cw_is_boxes">' +
        '                          Lådor' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_cw_boxes_qty)
        + '</span>' +

        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_cw_is_mirror_cabinet" ' +
        '                          id="kitchen_details_cw_is_mirror_cabinet" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_cw_is_mirror_cabinet) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_cw_is_mirror_cabinet">' +
        '                          Spegelskåp' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_cw_mirror_cabinet_qty)
        + '</span>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_cw_is_taka_connection" ' +
        '                          id="kitchen_details_cw_is_taka_connection" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_cw_is_taka_connection) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_cw_is_taka_connection">' +
        '                          Takanslutning' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_cw_taka_connection_qty)
        + '</span>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_cw_is_cover_pages" ' +
        '                          id="kitchen_details_cw_is_cover_pages" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_cw_is_cover_pages) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_cw_is_cover_pages">' +
        '                          Täcksidor' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_cw_cover_pages_qty)
        + '</span>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_cw_is_wall_cabinet" ' +
        '                          id="kitchen_details_cw_is_wall_cabinet" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_cw_is_wall_cabinet) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_cw_is_wall_cabinet">' +
        '                          Väggskåp' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_cw_wall_cabinet_qty)
        + '</span>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_cw_is_uncertain" ' +
        '                          id="kitchen_details_cw_is_uncertain" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_cw_is_uncertain) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_cw_is_uncertain">' +
        '                          Osäker/Vill rådfråga' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_cw_is_free_text" ' +
        '                          id="kitchen_details_cw_is_free_text" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_cw_is_free_text) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_cw_is_free_text">' +
        '                          Fritext' +
        '' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        // '                          <p [innerHTML]="kitchen.kitchen_details_cw_free_text | newline"></p>'+
        '    <p> ' + this.getFreetextValueDisplay(this.kitchen.kitchen_details_cw_free_text)
        + ' </p>' +
        '                      </div>' +
        '                    </div>' +
        '                  </div>' +
        '                </div>';
    }
    return (firstquestion !== '') ? this.generateQuestionTemplate('Installation av köksinredning', firstquestion) : firstquestion;
  }
  //#endregion
  //#region Second Quest Set
  generatehtmlForSecondQuestion() {
    let secondquestion = '';

    if (this.kitchen.kitchen_details_is_counter_tops) {
      secondquestion = '<div class="card-body">' +
        '                                <div class="row">' +
        '                                  <div class="col ml30">' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_ct_is_concrete" value="true" ' +
        '                                        id="kitchen_details_ct_is_concrete" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_ct_is_concrete) + ' >' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_ct_is_concrete">' +
        '                                        Betong' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ct_is_glass" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_ct_is_glass) +
        '                                        id="kitchen_details_ct_is_glass" >' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_ct_is_glass">' +
        '                                        Glas' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ct_is_composite" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_ct_is_composite) +
        '                                        id="kitchen_details_ct_is_composite">' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_ct_is_composite">' +
        '                                        Hi-Macs (Komposit)' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ct_is_tile" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_ct_is_tile) +
        '                                        id="kitchen_details_ct_is_tile">' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_ct_is_tile">' +
        '                                        Kakel' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ct_is_laminate" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_ct_is_laminate) +
        '                                        id="kitchen_details_ct_is_laminate">' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_ct_is_laminate">' +
        '                                        Laminat' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        '  value="true" name="kitchen_details_ct_is_massive_wood" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_ct_is_massive_wood) +
        '                                        id="kitchen_details_ct_is_massive_wood">' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_ct_is_massive_wood">' +
        '                                        Massivt trä' +
        '                                      </label>' +
        '                                    </div>' +
        '              ' +
        '                                  </div>' +
        '                                  <div class="col">' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ct_is_mosaic" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_ct_is_mosaic) +
        '                                        id="kitchen_details_ct_is_mosaic" >' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_ct_is_mosaic">' +
        '                                        Mosaik' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ct_is_rock_free" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_ct_is_rock_free) +
        '                                        id="kitchen_details_ct_is_rock_free">' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_ct_is_rock_free">' +
        '                                        Rotsfritt' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ct_is_granite" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_ct_is_granite) +
        '                                        id="kitchen_details_ct_is_granite">' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_ct_is_granite">' +
        '                                        Sten/Granit' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ct_is_uncertain" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_ct_is_uncertain) +
        '                                        id="kitchen_details_ct_is_uncertain">' +
        '    <label class="accordian-checkbox" for="kitchen_details_ct_is_uncertain">' +
        '                                        Osäker/Vill rådfråga' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ct_is_free_text" ' +
        this.getCheckBoxTernary(this.kitchen.kitchen_details_ct_is_free_text) +
        '                                        id="kitchen_details_ct_is_free_text" >' +
        ' <label class="accordian-checkbox" for="kitchen_details_ct_is_free_text">' +
        '                                        Fritext' +
        '                                      </label>' +
        '                                    </div>' +
        ' <div class="ml-10 ml">' +
        '    <p> ' + this.getFreetextValueDisplay(this.kitchen.kitchen_details_ct_free_text)
        + ' </p>' +
        '                                    </div>' +
        '              ' +
        '                                  </div>' +
        '                                </div>' +
        '                              </div>';


    }

    return (secondquestion !== '') ? this.generateQuestionTemplate('Bänkskivor', secondquestion) : secondquestion;
  }
  //#endregion
  //#region  Third Question Set
  generatehtmlForThirdQuestion() {
    // tslint:disable-next-line:prefer-const
    let thirdquestion = '';
    if (this.kitchen.kitchen_details_is_splash_back) {
      thirdquestion = '<div class="card-body">' +
        '                  <div class="row">' +
        '                    <div class="col ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox"  value="true" name="kitchen_details_sb_is_concrete"' +
        '                          id="kitchen_details_sb_is_concrete" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_sb_is_concrete) + ' >' +
        '                        <label class="accordian-checkbox" for="kitchen_details_sb_is_concrete">' +
        '                          Betong' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox"  value="true" name="kitchen_details_sb_is_glass"' +
        '                          id="kitchen_details_sb_is_glass" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_sb_is_glass) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_sb_is_glass">' +
        '                          Glas' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox"  value="true" name="kitchen_details_sb_is_composite" ' +
        '                          id="kitchen_details_sb_is_composite" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_sb_is_composite) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_sb_is_composite">' +
        '                          Hi-Macs (Komposit)' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox"  value="true" name="kitchen_details_sb_is_tile"  ' +
        '                          id="kitchen_details_sb_is_tile"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_sb_is_tile) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_sb_is_tile">' +
        '                          Kakel' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox"  value="true" name="kitchen_details_sb_is_laminate" ' +
        '                          id="kitchen_details_sb_is_laminate"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_sb_is_laminate) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_sb_is_laminate">' +
        '                          Laminat' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox"  value="true" name="kitchen_details_sb_is_mosaic" ' +
        '                          id="kitchen_details_sb_is_mosaic"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_sb_is_mosaic) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_sb_is_mosaic">' +
        '                          Mosaik' +
        '                        </label>' +
        '                      </div>' +
        '' +
        '' +
        '                    </div>' +
        '                    <div class="col">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox"  value="true"  ' +
        '                      '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_sb_is_painting) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_sb_is_painting">' +
        '                          Målning' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox"  value="true" name="kitchen_details_sb_is_rock_free" ' +
        '                          id="kitchen_details_sb_is_rock_free" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_sb_is_rock_free) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_sb_is_rock_free">' +
        '                          Rotsfritt' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox"  value="true" name="kitchen_details_sb_is_granite"  ' +
        '                          id="kitchen_details_sb_is_granite" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_sb_is_granite) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_sb_is_granite">' +
        '                          Sten/Granit' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox"  value="true" name="kitchen_details_sb_is_wallpaper" ' +
        '                          id="kitchen_details_sb_is_wallpaper" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_sb_is_wallpaper) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_sb_is_wallpaper">' +
        '                          Tapet' +
        '                        </label>' +
        '                      </div>' +
        '' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox"  value="true" name="kitchen_details_sb_is_uncertain"  ' +
        '                          id="kitchen_details_sb_is_uncertain" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_sb_is_uncertain) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_sb_is_uncertain">' +
        '                          Osäker/Vill rådfråga' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox"  value="true" name="kitchen_details_sb_is_free_text"  ' +
        '                          id="kitchen_details_sb_is_free_text" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_sb_is_free_text) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_sb_is_free_text">' +
        '                          Fritext' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10" style="margin-left: 30px;">' +
        '                          <p> ' + this.getFreetextValueDisplay(this.kitchen.kitchen_details_ct_free_text) + '</p>' +
        '                      </div>' +
        '' +
        '                    </div>' +
        '                  </div>' +
        '                </div>';
    }

    return (thirdquestion !== '') ? this.generateQuestionTemplate('Stänkskydd', thirdquestion) : thirdquestion;
  }
  //#endregion
  //#region Fourth Question Set
  generatehtmlForFourthQuestion() {
    // tslint:disable-next-line:prefer-const
    let fourthquestion = '';
    if (this.kitchen.kitchen_details_is_white_goods) {
      fourthquestion = '<div class="card-body">' +
        '                                <div class="row">' +
        '                                  <div class="col ml30">' +
        '                                    <div>' +
        '                                      <div class="form-check">' +
        '                                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wg_is_refrigerator"' +
        '                                          id="kitchen_details_wg_is_refrigerator"  '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wg_is_refrigerator) + '>' +
        '                                        <label class="accordian-checkbox" for="kitchen_details_wg_is_refrigerator">' +
        '                                          Kylskåp' +
        '                                        </label>' +
        '                                      </div>' +
        '              ' +
        '                                      <div class="form-check ml">' +
        '                                        <input class="form-check-input" type="checkbox" ' +
        '  value="true" name="kitchen_details_wg_is_refrigerator_free_standing"' +
        '                                          id="kitchen_details_wg_is_refrigerator_free_standing" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wg_is_refrigerator_free_standing) + '>' +
        '                                        <label class="accordian-checkbox" ' +
        ' for="kitchen_details_wg_is_refrigerator_free_standing">' +
        '                                          Fristående' +
        '                                        </label>' +
        '                                      </div>' +
        '                                      <div class="ml-10 ml">' +
        '                                          <span class="ml30"> '
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wg_refrigerator_free_standing_qty) + '</span>' +
        '                                      </div>' +
        '              ' +
        '                                      <div class="form-check ml">' +
        '                                        <input class="form-check-input" type="checkbox"  value="true" ' +
        ' name="kitchen_details_wg_is_refrigerator_integrated"' +
        '                                          id="kitchen_details_wg_is_refrigerator_integrated" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wg_is_refrigerator_integrated) + '>' +
        '                                        <label class="accordian-checkbox" for="kitchen_details_wg_is_refrigerator_integrated">' +
        '                                          Inbyggt' +
        '                                        </label>' +
        '                                      </div>' +
        '                                      <div class="ml-10 ml">' +
        '                                          <span class="ml30">  '
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wg_refrigerator_integrated_qty) + '</span>' +
        '                                      </div>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wg_is_freezer" ' +
        '                                        id="kitchen_details_wg_is_freezer" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wg_is_freezer) + ' >' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_wg_is_freezer">' +
        '                                        Frys' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wg_is_freezer_free_standing"' +
        '                                        id="kitchen_details_wg_is_freezer_free_standing" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wg_is_freezer_free_standing) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_wg_is_freezer_free_standing">' +
        '                                        Fristående' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="ml-10 ml">' +
        '                                        <span class="ml30"> '
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wg_freezer_free_standing_qty) + '</span>' +
        '                                    </div>' +
        '              ' +
        '                                    <div class="form-check ml">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wg_is_freezer_integrated"  ' +
        '                                        id="kitchen_details_wg_is_freezer_integrated" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wg_is_freezer_integrated) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_wg_is_freezer_integrated">' +
        '                                        Inbyggt' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="ml-10 ml">' +
        '                                        <span class="ml30"> '
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wg_freezer_integrated_qty) + '</span>' +
        '' +
        '                                    </div>' +
        '              ' +
        '              ' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wg_is_micro"  ' +
        '                                        id="kitchen_details_wg_is_micro" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wg_is_micro) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_wg_is_micro">' +
        '                                        Micro' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wg_is_micro_free_standing"' +
        '                                        id="kitchen_details_wg_is_micro_free_standing" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wg_is_micro_free_standing) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_wg_is_micro_free_standing">' +
        '                                        Fristående' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="ml-10 ml">' +
        '                                        <span class="ml30"> '
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wg_micro_free_standing_qty) + '</span>' +
        '      ' +
        '                                    </div>' +
        '              ' +
        '                                    <div class="form-check ml">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        '  value="true" name="kitchen_details_wg_is_micro_integrated"  ' +
        '                                        id="kitchen_details_wg_is_micro_integrated" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wg_is_micro_integrated) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_wg_is_micro_integrated">' +
        '                                        Inbyggt' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="ml-10 ml" >' +
        '                                        <span class="ml30"> '
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wg_micro_integrated_qty) + '</span>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wg_is_built_in_oven" ' +
        '                                        id="kitchen_details_wg_is_built_in_oven" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wg_is_built_in_oven) + ' >' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_wg_is_built_in_oven">' +
        '                                        Inbyggd ugn' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="ml-10 ml">' +
        '                                        <span class="ml30"> '
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wg_is_built_in_oven_qty) + '</span>' +
        '' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wg_is_stove_top" ' +
        '                                        id="kitchen_details_wg_is_stove_top" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wg_is_stove_top) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_wg_is_stove_top">' +
        '                                        Spishäll' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="ml-10 ml" >' +
        '                                        <span class="ml30"> '
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wg_is_stove_top_qty) + '</span>' +
        '                                    </div>' +
        '              ' +
        '              ' +
        '              ' +
        '                                  </div>' +
        '                                  <div class="col">' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wg_is_gas_cooker" ' +
        '                                        id="kitchen_details_wg_is_gas_cooker" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wg_is_gas_cooker) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_wg_is_gas_cooker">' +
        '                                        Gasspis' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="ml-10 ml" >' +
        '                                        <span class="ml30"> '
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wg_is_gas_cooker_qty) + '</span>' +
        '  ' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wg_is_free_standing_stove" ' +
        '                                        id="kitchen_details_wg_is_free_standing_stove" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wg_is_free_standing_stove) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_wg_is_free_standing_stove">' +
        '                                        Fristående spis' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="ml-10 ml">' +
        '                                        <span class="ml30"> '
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wg_is_free_standing_stove_qty) + '</span>' +
        '        ' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wg_is_dish_washer" ' +
        '                                        id="kitchen_details_wg_is_dish_washer" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wg_is_dish_washer) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_wg_is_dish_washer">' +
        '                                        Diskmaskin' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="ml-10 ml">' +
        '                                        <span class="ml30"> '
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wg_is_dish_washer_qty) + '</span>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wg_is_fan" ' +
        '                                        id="kitchen_details_wg_is_fan" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wg_is_fan) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_wg_is_fan">' +
        '                                        Fläkt' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="ml-10 ml">' +
        '                                        <span class="ml30"> '
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wg_is_fan_qty) + '</span>' +
        '                                    </div>' +
        '              ' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wg_is_free_text" ' +
        '                                        id="kitchen_details_wg_is_free_text" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wg_is_free_text) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_wg_is_free_text">' +
        '                                        Fritext' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="ml-10 ml">' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wg_free_text) + '</p>' +
        '    ' +
        '                                    </div>' +
        '              ' +
        '                                  </div>' +
        '                                </div>' +
        '                              </div>';

    }

    return (fourthquestion !== '') ? this.generateQuestionTemplate('Vitvaror', fourthquestion) : fourthquestion;
  }

  //#endregion
  //#region Fiveth Question Set

  generatehtmlForFivethQuestion() {
    // tslint:disable-next-line:prefer-const
    let fivethquestion = '';
    if (this.kitchen.kitchen_details_is_el) {
      fivethquestion = '<div class="card-body">' +
        '                  <div class="row">' +
        '                    <div class="col ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" '
        + ' value="true" name="kitchen_details_el_is_troubleshooting"' +
        '                          id="kitchen_details_el_is_troubleshooting" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_el_is_troubleshooting) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_el_is_troubleshooting">' +
        '                          Felsökning' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" '
        + ' value="true" name="kitchen_details_el_is_retraction_of_electricity"' +
        '                          id="kitchen_details_el_is_retraction_of_electricity" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_el_is_retraction_of_electricity) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_el_is_retraction_of_electricity">' +
        '                          Indragning av el' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" '
        + ' value="true" name="kitchen_details_el_is_recessed_elongation"' +
        '                          id="kitchen_details_el_is_recessed_elongation" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_el_is_recessed_elongation) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_el_is_recessed_elongation">' +
        '                          Infälld eldragning' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" '
        + '  value="true" name="kitchen_details_el_is_lighting" ' +
        '                          id="kitchen_details_el_is_lighting" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_el_is_lighting) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_el_is_lighting">' +
        '                          Belysning' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" '
        + ' value="true" name="kitchen_details_el_is_electric_floor_heating" ' +
        '                          id="kitchen_details_el_is_electric_floor_heating" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_el_is_electric_floor_heating) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_el_is_electric_floor_heating">' +
        '                          Elektrisk golvvärme' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" '
        + ' value="true" name="kitchen_details_el_is_appliance" ' +
        '                          id="kitchen_details_el_is_appliance"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_el_is_appliance) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_el_is_appliance">' +
        '                          Apparat (diskmaskin mm)' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" '
        + '  value="true" name="kitchen_details_el_is_fire_alarm"' +
        '                          id="kitchen_details_el_is_fire_alarm"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_el_is_fire_alarm) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_el_is_fire_alarm">' +
        '                          Brandlarm' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" '
        + ' value="true" name="kitchen_details_el_is_telecommunications_network" ' +
        '                          id="kitchen_details_el_is_telecommunications_network"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_el_is_telecommunications_network) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_el_is_telecommunications_network">' +
        '                          Data-/telenätverk' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox"  value="true" '
        + ' name="kitchen_details_el_is_RCD"' +
        '                          id="kitchen_details_el_is_RCD"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_el_is_RCD) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_el_is_RCD">' +
        '                          Jordfelsbrytare' +
        '                        </label>' +
        '                      </div>' +
        '' +
        '' +
        '                    </div>' +
        '                    <div class="col">' +
        '' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" '
        + ' value="true" name="kitchen_details_el_is_electrical_socket"' +
        '                          id="kitchen_details_el_is_electrical_socket"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_el_is_electrical_socket) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_el_is_electrical_socket">' +
        '                          Eluttag/strömbrytare/dimmer' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" '
        + '  value="true" name="kitchen_details_el_is_radiators"' +
        '                          id="kitchen_details_el_is_radiators"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_el_is_radiators) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_el_is_radiators">' +
        '                          Element, radiatorer' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" '
        + ' value="true" name="kitchen_details_el_is_spotlights"' +
        '                          id="kitchen_details_el_is_spotlights"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_el_is_spotlights) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_el_is_spotlights">' +
        '                          Spotlights' +
        '                        </label>' +
        '                      </div>' +
        '' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox"  '
        + ' value="true" name="kitchen_details_el_is_fan"' +
        '                          id="kitchen_details_el_is_fan"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_el_is_fan) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_el_is_fan">' +
        '                          Fläkt' +
        '                        </label>' +
        '                      </div>' +
        '' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" '
        + ' value="true" name="kitchen_details_el_is_elimination_of_electricity"' +
        '                          id="kitchen_details_el_is_elimination_of_electricity"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_el_is_elimination_of_electricity) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_el_is_elimination_of_electricity">' +
        '                          Omdragning av el' +
        '                        </label>' +
        '                      </div>' +
        '' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" '
        + ' value="true" name="kitchen_details_el_is_surface_electricity"' +
        '                          id="kitchen_details_el_is_surface_electricity" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_el_is_surface_electricity) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_el_is_surface_electricity">' +
        '                          Utanpåliggande el' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" '
        + ' value="true" name="kitchen_details_el_is_uncertain"' +
        '                          id="kitchen_details_el_is_uncertain" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_el_is_uncertain) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_el_is_uncertain">' +
        '                          Osäker/Vill rådfråga' +
        '                        </label>' +
        '                      </div>' +
        '' +
        '' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" '
        + ' value="true" name="kitchen_details_el_is_free_text"' +
        '                          id="kitchen_details_el_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_el_is_free_text) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_el_is_free_text">' +
        '                          Fritext' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-group" style="margin-left: 30px;">' +
        // '                          <p [innerHTML]="kitchen.kitchen_details_el_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_el_free_text) + '</p>' +
        '                      </div>' +
        '' +
        '                    </div>' +
        '                  </div>' +
        '                </div>';
    }

    return (fivethquestion !== '') ? this.generateQuestionTemplate('EI', fivethquestion) : fivethquestion;
  }
  //#endregion
  //#region Sixth Question Set
  generatehtmlForSixthQuestion() {
    // tslint:disable-next-line:prefer-const
    let sixthquestion = '';
    if (this.kitchen.kitchen_details_is_plumbing) {
      sixthquestion = '<div class="card-body">' +
        '                            <div class="row">' +
        '                              <div class="col ml30">' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_pl_is_installation_of_mixer" ' +
        '                                    id="kitchen_details_pl_is_installation_of_mixer" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_pl_is_installation_of_mixer) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_pl_is_installation_of_mixer">' +
        '                                    Installation av blandare' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_pl_is_floor_drain" ' +
        '                                    id="kitchen_details_pl_is_floor_drain" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_pl_is_floor_drain) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_pl_is_floor_drain">' +
        '                                    Golvbrunn' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_pl_is_installation_of_water" ' +
        '                                    id="kitchen_details_pl_is_installation_of_water" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_pl_is_installation_of_water) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_pl_is_installation_of_water">' +
        '                                    Installation av vattenburen golvvärme' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_pl_is_piping" ' +
        '                                    id="kitchen_details_pl_is_piping" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_pl_is_piping) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_pl_is_piping">' +
        '                                    Rörsystem' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_pl_is_water_pipe" ' +
        '                                    id="kitchen_details_pl_is_water_pipe"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_pl_is_water_pipe) + ' >' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_pl_is_water_pipe">' +
        '                                    Vattenrör' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_pl_is_appliance" ' +
        '                                    id="kitchen_details_pl_is_appliance" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_pl_is_appliance) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_pl_is_appliance">' +
        '                                    Apparat (diskmaskin mm)' +
        '                                  </label>' +
        '                                </div>' +
        '          ' +
        '          ' +
        '                              </div>' +
        '                              <div class="col">' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_pl_is_water_heater"' +
        '                                    id="kitchen_details_pl_is_water_heater" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_pl_is_water_heater) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_pl_is_water_heater">' +
        '                                    Varmvattenberedare' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_pl_is_drainage_pipes"' +
        '                                    id="kitchen_details_pl_is_drainage_pipes" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_pl_is_drainage_pipes) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_pl_is_drainage_pipes">' +
        '                                    Avloppsrör' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_pl_is_installation_of_water_trap" ' +
        '                                    id="kitchen_details_pl_is_installation_of_water_trap" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_pl_is_installation_of_water_trap) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_pl_is_installation_of_water_trap">' +
        '                                    Installation av vattenlås' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_pl_is_uncertain" ' +
        '                                    id="kitchen_details_pl_is_uncertain" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_pl_is_uncertain) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_pl_is_uncertain">' +
        '                                    Osäker/Vill rådfråga' +
        '                                  </label>' +
        '                                </div>' +
        '          ' +
        '          ' +
        '          ' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_pl_is_free_text"' +
        '                                    id="kitchen_details_pl_is_free_text" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_pl_is_free_text) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_pl_is_free_text">' +
        '                                    Fritext' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-group" style="margin-left: 30px;">' +
        // '                                    <p [innerHTML]="kitchen.kitchen_details_pl_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_pl_free_text) + '</p>' +
        '                                </div>' +
        '          ' +
        '                              </div>' +
        '                            </div>' +
        '                          </div>';
    }

    return (sixthquestion !== '') ? this.generateQuestionTemplate('VVS', sixthquestion) : sixthquestion;
  }
  //#endregion
  //#region Seventh Question Set
  generatehtmlForSeventhQuestion() {
    // tslint:disable-next-line:prefer-const
    let seventhquestion = '';
    if (this.kitchen.kitchen_details_is_floor) {
      seventhquestion = '<div class="card-body">' +
        '                            <div class="row">' +
        '                              <div class="col ml30">' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_fl_is_add_new_floor" ' +
        '                                    id="kitchen_details_fl_is_add_new_floor" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_is_add_new_floor) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_is_add_new_floor">' +
        '                                    Lägg nytt golv' +
        '                                  </label>' +
        '                                </div>' +
        '                              </div>' +
        '                            </div>' +
        '                            <div class="row">'
        +
        this.getFirstSet() +
        '</div>' +
        '<div class="row">' +
        this.getSecondSet() +
        '</div>' +
        '<div class="row">' +
        this.getThirdSet() +
        '</div>' +
        '<div class="row">' +
        this.getFourthSet() +
        '</div>' +
        '<div class="row">' +
        this.getFivethSet() +
        '</div>' +
        '<div class="row">' +
        this.getSixththSet() +
        '</div>' +
        '<div class="row">' +
        this.getSeventhSet() +
        '</div>' +
        '<div class="row">' +
        this.getNinethSet() +
        '</div>' +
        '<div class="row">' +
        this.getEighthSet() +
        '</div>' +
        '<div class="row">' +
        this.getTenththSet() +
        '</div>' +
        this.getElevenththSet() +
        // this.getFourthSet() +
        // this.getFivethSet() +
        // this.getSixththSet() +
        // this.getSeventhSet() +
        // this.getEighthSet() +
        // this.getNinethSet() +
        // this.getTenththSet() +
        // this.getElevenththSet() +
        '</div>';
    }
    return (seventhquestion !== '') ? this.generateQuestionTemplate('Golv', seventhquestion) : seventhquestion;
  }

  getFirstSet() {
    let select = '';
    if (this.kitchen.kitchen_details_fl_anf_is_concrete_floors) {
      select = '                              <div class="col-12 ml30">' +
        '                                <div class="form-check ml">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_anf_is_concrete_floors" ' +
        '                                    id="kitchen_details_fl_anf_is_concrete_floors" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_is_concrete_floors) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_anf_is_concrete_floors">' +
        '                                    Betonggolv' +
        '                                  </label>' +
        '                                </div>' +
        '          ' +
        '                                <div class="row">' +
        '                                  <div class="col ml30">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label">Vill du behandla ditt nya golv?</label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_icf_is_joining" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_icf_is_joining" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_icf_is_joining) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_icf_is_joining">' +
        '                                        Fogning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_icf_is_hardwax" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_icf_is_hardwax" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_icf_is_hardwax) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_icf_is_hardwax">' +
        '                                        Hårdvaxolja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_icf_is_lacquer" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_icf_is_lacquer" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_icf_is_lacquer) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_icf_is_lacquer">' +
        '                                        Lack' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_icf_is_lasering" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_icf_is_lasering" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_icf_is_lasering) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_icf_is_lasering">' +
        '                                        Lasering' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_icf_is_lye" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_icf_is_lye" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_icf_is_lye) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_icf_is_lye">' +
        '                                        Lut' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_icf_is_painting" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_icf_is_painting) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_icf_is_painting">' +
        '                                        Målning' +
        '                                      </label>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                  <div class="col">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label"></label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_icf_is_oil" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_icf_is_oil" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_icf_is_oil) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_icf_is_oil">' +
        '                                        Olja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_icf_is_grinding" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_icf_is_grinding" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_icf_is_grinding) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_icf_is_grinding">' +
        '                                        Slipning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_icf_is_soap" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_icf_is_soap" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_icf_is_soap) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_icf_is_soap">' +
        '                                        Såpa' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_icf_is_uncertain" value="true"' +
        '                                        id="kitchen_details_fl_anf_wttnf_icf_is_uncertain" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_icf_is_uncertain) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_icf_is_uncertain">' +
        '                                        Osäker/Vill rådfråga' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_icf_is_free_text" value="true"' +
        '                                        id="kitchen_details_fl_anf_wttnf_icf_is_free_text" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_icf_is_free_text) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_icf_is_free_text">' +
        '                                        Fritext' +
        // '                                        <small class="text-danger" >(maximum 50 chacracters)</small>'+
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-group" style="margin-left: 30px;" >' +
        // '                                        <p [innerHTML]="kitchen.kitchen_details_fl_anf_wttnf_icf_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_fl_anf_wttnf_icf_free_text) + '</p>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                </div>' +
        '          ' +
        '                              </div>';
    }
    return select;
  }

  getSecondSet() {
    let select = '';
    if (this.kitchen.kitchen_details_fl_anf_is_tiled_floor) {
      select = ' <div class="col-12 ml30">' +
        '                                <div class="form-check ml">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_anf_is_tiled_floor" ' +
        '                                    id="kitchen_details_fl_anf_is_tiled_floor" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_is_tiled_floor) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_anf_is_tiled_floor">' +
        '                                    Klinkergolv' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="row">' +
        '                                  <div class="col ml30">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label">Vill du behandla ditt nya golv?</label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_itf_is_joining" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_itf_is_joining" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_itf_is_joining) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_itf_is_joining">' +
        '                                        Fogning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_itf_is_hardwax" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_itf_is_hardwax" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_itf_is_hardwax) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_itf_is_hardwax">' +
        '                                        Hårdvaxolja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_itf_is_lacquer" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_itf_is_lacquer" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_itf_is_lacquer) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_itf_is_lacquer">' +
        '                                        Lack' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_itf_is_lasering" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_itf_is_lasering" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_itf_is_lasering) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_itf_is_lasering">' +
        '                                        Lasering' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_itf_is_lye" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_itf_is_lye" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_itf_is_lye) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_itf_is_lye">' +
        '                                        Lut' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_itf_is_painting" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_itf_is_painting) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_itf_is_painting">' +
        '                                        Målning' +
        '                                      </label>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                  <div class="col">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label"></label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_itf_is_oil" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_itf_is_oil" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_itf_is_oil) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_itf_is_oil">' +
        '                                        Olja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_itf_is_grinding" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_itf_is_grinding" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_itf_is_grinding) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_itf_is_grinding">' +
        '                                        Slipning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_itf_is_soap" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_itf_is_soap" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_itf_is_soap) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_itf_is_soap">' +
        '                                        Såpa' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_itf_is_uncertain" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_itf_is_uncertain" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_itf_is_uncertain) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_itf_is_uncertain">' +
        '                                        Osäker/Vill rådfråga' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_itf_is_free_text" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_itf_is_free_text" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_itf_is_free_text) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_itf_is_free_text">' +
        '                                        Fritext' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-group" style="margin-left: 30px;">' +
        // '                                        <p [innerHTML]="kitchen.kitchen_details_fl_anf_wttnf_itf_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_fl_anf_wttnf_itf_free_text) + '</p>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                </div>' +
        '                              </div>';

    }
    return select;
  }

  getThirdSet() {
    let select = '';
    if (this.kitchen.kitchen_details_fl_anf_is_laminate) {
      select = '<div class="col-12 ml30">' +
        '                                <div class="form-check ml">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_anf_is_laminate" ' +
        '                                    id="kitchen_details_fl_anf_is_laminate" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_is_laminate) + ' >' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_anf_is_laminate">' +
        '                                    Laminatgolv' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="row">' +
        '                                  <div class="col ml30">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label">Vill du behandla ditt nya golv?</label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_il_is_joining" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_il_is_joining" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_il_is_joining) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_il_is_joining">' +
        '                                        Fogning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_il_is_hardwax" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_il_is_hardwax" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_il_is_hardwax) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_il_is_hardwax">' +
        '                                        Hårdvaxolja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_il_is_lacquer" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_il_is_lacquer" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_il_is_lacquer) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_il_is_lacquer">' +
        '                                        Lack' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_il_is_lasering" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_il_is_lasering" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_il_is_lasering) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_il_is_lasering">' +
        '                                        Lasering' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_il_is_lye" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_il_is_lye"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_il_is_lye) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_il_is_lye">' +
        '                                        Lut' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_il_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_il_is_painting) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_il_is_painting">' +
        '                                        Målning' +
        '                                      </label>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                  <div class="col">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label"></label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_il_is_oil" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_il_is_oil"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_il_is_oil) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_il_is_oil">' +
        '                                        Olja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_il_is_grinding" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_il_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_il_is_grinding) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_il_is_grinding">' +
        '                                        Slipning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_il_is_soap" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_il_is_soap"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_il_is_soap) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_il_is_soap">' +
        '                                        Såpa' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_il_is_uncertain" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_il_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_il_is_uncertain) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_il_is_uncertain">' +
        '                                        Osäker/Vill rådfråga' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_il_is_free_text" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_il_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_il_is_free_text) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_il_is_free_text">' +
        '                                        Fritext' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-group" style="margin-left: 30px;">' +
        // '                                        <p [innerHTML]="kitchen.kitchen_details_fl_anf_wttnf_il_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_fl_anf_wttnf_il_free_text) + '</p>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                </div>' +
        '                              </div>';
    }
    return select;
  }

  getFourthSet() {
    let select = '';
    if (this.kitchen.kitchen_details_fl_anf_is_vinyl) {
      select = '<div class="col-12 ml30">' +
        '                                <div class="form-check ml">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_anf_is_vinyl" ' +
        '                                    id="kitchen_details_fl_anf_is_vinyl" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_is_vinyl) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_anf_is_vinyl">' +
        '                                    Plastmatta' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="row">' +
        '                                  <div class="col ml30">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label">Vill du behandla ditt nya golv?</label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iv_is_joining" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iv_is_joining" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iv_is_joining) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iv_is_joining">' +
        '                                        Fogning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iv_is_hardwax" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iv_is_hardwax" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iv_is_hardwax) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iv_is_hardwax">' +
        '                                        Hårdvaxolja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iv_is_lacquer" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iv_is_lacquer" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iv_is_lacquer) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iv_is_lacquer">' +
        '                                        Lack' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iv_is_lasering" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iv_is_lasering" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iv_is_lasering) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iv_is_lasering">' +
        '                                        Lasering' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iv_is_lye" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iv_is_lye"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iv_is_lye) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iv_is_lye">' +
        '                                        Lut' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iv_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iv_is_painting) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iv_is_painting">' +
        '                                        Målning' +
        '                                      </label>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                  <div class="col">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label"></label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iv_is_oil" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iv_is_oil"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iv_is_oil) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iv_is_oil">' +
        '                                        Olja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iv_is_grinding" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iv_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iv_is_grinding) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iv_is_grinding">' +
        '                                        Slipning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iv_is_soap" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iv_is_soap"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iv_is_soap) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iv_is_soap">' +
        '                                        Såpa' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iv_is_uncertain" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iv_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iv_is_uncertain) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iv_is_uncertain">' +
        '                                        Osäker/Vill rådfråga' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iv_is_free_text" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iv_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iv_is_free_text) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iv_is_free_text">' +
        '                                        Fritext' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-group" style="margin-left: 30px;">' +
        // '                                        <p [innerHTML]="kitchen.kitchen_details_fl_anf_wttnf_iv_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_fl_anf_wttnf_iv_free_text) + '</p>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                </div>' +
        '                              </div>';
    }
    return select;
  }


  getFivethSet() {
    let select = '';
    if (this.kitchen.kitchen_details_fl_anf_is_parquet_floor) {
      select = '                              <div class="col-12 ml30">' +
        '                                <div class="form-check ml">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_anf_is_parquet_floor" ' +
        '                                    id="kitchen_details_fl_anf_is_parquet_floor" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_is_parquet_floor) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_anf_is_parquet_floor">' +
        '                                    Parkettgolv' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="row">' +
        '                                  <div class="col ml30">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label">Vill du behandla ditt nya golv?</label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ipf_is_joining" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ipf_is_joining" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ipf_is_joining) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ipf_is_joining">' +
        '                                        Fogning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ipf_is_hardwax" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ipf_is_hardwax" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ipf_is_hardwax) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ipf_is_hardwax">' +
        '                                        Hårdvaxolja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ipf_is_lacquer" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ipf_is_lacquer" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ipf_is_lacquer) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ipf_is_lacquer">' +
        '                                        Lack' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ipf_is_lasering" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ipf_is_lasering" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ipf_is_lasering) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ipf_is_lasering">' +
        '                                        Lasering' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ipf_is_lye" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ipf_is_lye" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ipf_is_lye) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ipf_is_lye">' +
        '                                        Lut' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ipf_is_painting" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ipf_is_painting) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ipf_is_painting">' +
        '                                        Målning' +
        '                                      </label>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                  <div class="col">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label"></label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ipf_is_oil" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ipf_is_oil" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ipf_is_oil) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ipf_is_oil">' +
        '                                        Olja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ipf_is_grinding" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ipf_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ipf_is_grinding) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ipf_is_grinding">' +
        '                                        Slipning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ipf_is_soap" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ipf_is_soap"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ipf_is_soap) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ipf_is_soap">' +
        '                                        Såpa' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ipf_is_uncertain" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ipf_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ipf_is_uncertain) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ipf_is_uncertain">' +
        '                                        Osäker/Vill rådfråga' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ipf_is_free_text" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ipf_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ipf_is_free_text) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ipf_is_free_text">' +
        '                                        Fritext' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-group" style="margin-left: 30px;" >' +
        // '                                        <p [innerHTML]="kitchen.kitchen_details_fl_anf_wttnf_ipf_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_fl_anf_wttnf_ipf_free_text) + '</p>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                </div>' +
        '                              </div>';

    }
    return select;
  }

  getSixththSet() {
    let select = '';
    if (this.kitchen.kitchen_details_fl_anf_is_carpet) {
      select = '                              <div class="col-12 ml30">' +
        '          ' +
        '                                <div class="form-check ml">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_anf_is_carpet" ' +
        '                                    id="kitchen_details_fl_anf_is_carpet" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_is_carpet) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_anf_is_carpet">' +
        '                                    Matta' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="row">' +
        '                                  <div class="col ml30">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label">Vill du behandla ditt nya golv?</label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ic_is_joining" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ic_is_joining" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ic_is_joining) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ic_is_joining">' +
        '                                        Fogning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ic_is_hardwax" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ic_is_hardwax" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ic_is_hardwax) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ic_is_hardwax">' +
        '                                        Hårdvaxolja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ic_is_lacquer" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ic_is_lacquer" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ic_is_lacquer) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ic_is_lacquer">' +
        '                                        Lack' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ic_is_lasering" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ic_is_lasering"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ic_is_lasering) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ic_is_lasering">' +
        '                                        Lasering' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ic_is_lye" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ic_is_lye"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ic_is_lye) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ic_is_lye">' +
        '                                        Lut' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ic_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ic_is_painting) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ic_is_painting">' +
        '                                        Målning' +
        '                                      </label>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                  <div class="col">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label"></label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ic_is_oil" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ic_is_oil"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ic_is_oil) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ic_is_oil">' +
        '                                        Olja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ic_is_grinding" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ic_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ic_is_grinding) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ic_is_grinding">' +
        '                                        Slipning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ic_is_soap" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ic_is_soap"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ic_is_soap) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ic_is_soap">' +
        '                                        Såpa' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ic_is_uncertain" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ic_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ic_is_uncertain) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ic_is_uncertain">' +
        '                                        Osäker/Vill rådfråga' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ic_is_free_text" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ic_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ic_is_free_text) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ic_is_free_text">' +
        '                                        Fritext' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-group" style="margin-left: 30px;" >' +
        // '                                        <p [innerHTML]="kitchen.kitchen_details_fl_anf_wttnf_ic_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_fl_anf_wttnf_ic_free_text) + '</p>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                </div>' +
        '                              </div>';
    }
    return select;
  }

  getSeventhSet() {
    let select = '';
    if (this.kitchen.kitchen_details_fl_anf_is_tessellation) {
      select = '<div class="col-12 ml30">' +
        '          ' +
        '                                <div class="form-check ml">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_anf_is_tessellation" ' +
        '                                    id="kitchen_details_fl_anf_is_tessellation"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_is_tessellation) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_anf_is_tessellation">' +
        '                                    Mosaikgolv' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="row">' +
        '                                  <div class="col ml30">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label">Vill du behandla ditt nya golv?</label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_it_is_joining" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_it_is_joining"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_it_is_joining) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_it_is_joining">' +
        '                                        Fogning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_it_is_hardwax" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_it_is_hardwax"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_it_is_hardwax) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_it_is_hardwax">' +
        '                                        Hårdvaxolja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_it_is_lacquer" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_it_is_lacquer"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_it_is_lacquer) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_it_is_lacquer">' +
        '                                        Lack' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_it_is_lasering" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_it_is_lasering"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_it_is_lasering) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_it_is_lasering">' +
        '                                        Lasering' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_it_is_lye" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_it_is_lye"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_it_is_lye) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_it_is_lye">' +
        '                                        Lut' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_it_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_it_is_painting) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_it_is_painting">' +
        '                                        Målning' +
        '                                      </label>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                  <div class="col">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label"></label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_it_is_oil" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_it_is_oil"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_it_is_oil) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_it_is_oil">' +
        '                                        Olja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_it_is_grinding" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_it_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_it_is_grinding) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_it_is_grinding">' +
        '                                        Slipning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_it_is_soap" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_it_is_soap"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_it_is_soap) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_it_is_soap">' +
        '                                        Såpa' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_it_is_uncertain" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_it_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_it_is_uncertain) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_it_is_uncertain">' +
        '                                        Osäker/Vill rådfråga' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_it_is_free_text" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_it_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_it_is_free_text) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_it_is_free_text">' +
        '                                        Fritext' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-group" style="margin-left: 30px;" >' +
        // '                                        <p [innerHTML]="kitchen.kitchen_details_fl_anf_wttnf_it_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_fl_anf_wttnf_it_free_text) + '</p>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                </div>' +
        '                              </div>';
    }
    return select;
  }
  getEighthSet() {
    let select = '';
    if (this.kitchen.kitchen_details_fl_anf_is_wood_floors) {
      select = '                              <div class="col-12 ml30">' +
        '          ' +
        '                                <div class="form-check ml">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_anf_is_wood_floors" ' +
        '                                    id="kitchen_details_fl_anf_is_wood_floors"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_is_wood_floors) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_anf_is_wood_floors">' +
        '                                    Trägolv' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="row">' +
        '                                  <div class="col ml30">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label">Vill du behandla ditt nya golv?</label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iwf_is_joining" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iwf_is_joining"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iwf_is_joining) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iwf_is_joining">' +
        '                                        Fogning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iwf_is_hardwax" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iwf_is_hardwax"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iwf_is_hardwax) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iwf_is_hardwax">' +
        '                                        Hårdvaxolja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iwf_is_lacquer" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iwf_is_lacquer"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iwf_is_lacquer) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iwf_is_lacquer">' +
        '                                        Lack' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iwf_is_lasering" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iwf_is_lasering"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iwf_is_lasering) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iwf_is_lasering">' +
        '                                        Lasering' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iwf_is_lye" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iwf_is_lye"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iwf_is_lye) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iwf_is_lye">' +
        '                                        Lut' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iwf_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iwf_is_painting) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iwf_is_painting">' +
        '                                        Målning' +
        '                                      </label>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                  <div class="col">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label"></label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iwf_is_oil" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iwf_is_oil"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iwf_is_oil) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iwf_is_oil">' +
        '                                        Olja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iwf_is_grinding" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iwf_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iwf_is_grinding) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iwf_is_grinding">' +
        '                                        Slipning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iwf_is_soap" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iwf_is_soap"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iwf_is_soap) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iwf_is_soap">' +
        '                                        Såpa' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iwf_is_uncertain" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iwf_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iwf_is_uncertain) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iwf_is_uncertain">' +
        '                                        Osäker/Vill rådfråga' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iwf_is_free_text" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iwf_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iwf_is_free_text) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iwf_is_free_text">' +
        '                                        Fritext' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-group" style="margin-left: 30px;" >' +
        // '                                        <p [innerHTML]="kitchen.kitchen_details_fl_anf_wttnf_iwf_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_fl_anf_wttnf_iwf_free_text) + '</p>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                </div>' +
        '                              </div>';
    }
    return select;
  }
  getNinethSet() {
    let select = '';
    if (this.kitchen.kitchen_details_fl_anf_is_granite_floor) {
      select = '                              <div class="col-12 ml30">' +
        '          ' +
        '                                <div class="form-check ml">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_is_granite_floor" value="true" ' +
        '                                    id="kitchen_details_fl_anf_is_granite_floor"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_is_granite_floor) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_anf_is_granite_floor">' +
        '                                    Sten/Granitgolv' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="row">' +
        '                                  <div class="col ml30">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label">Vill du behandla ditt nya golv?</label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_igf_is_joining" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_igf_is_joining"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_igf_is_joining) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_igf_is_joining">' +
        '                                        Fogning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_igf_is_hardwax" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_igf_is_hardwax"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_igf_is_hardwax) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_igf_is_hardwax">' +
        '                                        Hårdvaxolja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_igf_is_lacquer" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_igf_is_lacquer"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_igf_is_lacquer) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_igf_is_lacquer">' +
        '                                        Lack' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_igf_is_lasering" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_igf_is_lasering"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_igf_is_lasering) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_igf_is_lasering">' +
        '                                        Lasering' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_igf_is_lye" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_igf_is_lye"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_igf_is_lye) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_igf_is_lye">' +
        '                                        Lut' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_igf_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_igf_is_painting) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_igf_is_painting">' +
        '                                        Målning' +
        '                                      </label>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                  <div class="col">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label"></label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_igf_is_oil" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_igf_is_oil"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_igf_is_oil) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_igf_is_oil">' +
        '                                        Olja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_igf_is_grinding" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_igf_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_igf_is_grinding) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_igf_is_grinding">' +
        '                                        Slipning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_igf_is_soap" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_igf_is_soap"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_igf_is_soap) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_igf_is_soap">' +
        '                                        Såpa' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_igf_is_uncertain" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_igf_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_igf_is_uncertain) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_igf_is_uncertain">' +
        '                                        Osäker/Vill rådfråga' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_igf_is_free_text" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_igf_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_igf_is_free_text) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_igf_is_free_text">' +
        '                                        Fritext' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-group" style="margin-left: 30px;" >' +
        // '                                        <p [innerHTML]="kitchen.kitchen_details_fl_anf_wttnf_igf_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_fl_anf_wttnf_igf_free_text) + '</p>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                </div>' +
        '                              </div>';
    }
    return select;
  }

  getTenththSet() {
    let select = '';
    if (this.kitchen.kitchen_details_fl_anf_is_uncertain) {
      select = '<div class="col-12 ml30">' +
        '                                <div class="form-check ml">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_anf_is_uncertain" ' +
        '                                    id="kitchen_details_fl_anf_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_is_uncertain) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_anf_is_uncertain">' +
        '                                    Osäker/Vill rådfråga' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="row">' +
        '                                  <div class="col ml30">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label">Vill du behandla ditt nya golv?</label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iun_is_joining" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iun_is_joining" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iun_is_joining) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iun_is_joining">' +
        '                                        Fogning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iun_is_hardwax" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iun_is_hardwax"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iun_is_hardwax) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iun_is_hardwax">' +
        '                                        Hårdvaxolja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iun_is_lacquer" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iun_is_lacquer"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iun_is_lacquer) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iun_is_lacquer">' +
        '                                        Lack' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iun_is_lasering" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iun_is_lasering"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iun_is_lasering) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iun_is_lasering">' +
        '                                        Lasering' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iun_is_lye" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iun_is_lye"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iun_is_lye) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iun_is_lye">' +
        '                                        Lut' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iun_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iun_is_painting) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iun_is_painting">' +
        '                                        Målning' +
        '                                      </label>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                  <div class="col">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label"></label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iun_is_oil" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iun_is_oil"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iun_is_oil) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iun_is_oil">' +
        '                                        Olja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iun_is_grinding" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iun_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iun_is_grinding) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iun_is_grinding">' +
        '                                        Slipning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iun_is_soap" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iun_is_soap"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iun_is_soap) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iun_is_soap">' +
        '                                        Såpa' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iun_is_uncertain" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iun_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iun_is_uncertain) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iun_is_uncertain">' +
        '                                        Osäker/Vill rådfråga' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_iun_is_free_text" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_iun_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_iun_is_free_text) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_iun_is_free_text">' +
        '                                        Fritext' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-group" style="margin-left: 30px;" >' +
        // '                                        <p [innerHTML]="kitchen.kitchen_details_fl_anf_wttnf_iun_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_fl_anf_wttnf_iun_free_text) + '</p>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                </div>' +
        '          ' +
        '                              </div>' +
        '                              <div class="col-12 ml30">' +
        '                                <div class="form-check ml">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_anf_is_free_text" ' +
        '                                    id="kitchen_details_fl_anf_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_is_free_text) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_anf_is_free_text">' +
        '                                    Fritext' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-group" style="margin-left: 30px;">' +
        // '                                    <p [innerHTML]="kitchen.kitchen_details_fl_anf_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_fl_anf_free_text) + '</p>' +
        '                                </div>' +
        '          ' +
        '                                <div class="row">' +
        '                                  <div class="col ml30">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label">Vill du behandla ditt nya golv?</label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ift_is_joining" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ift_is_joining"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ift_is_joining) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ift_is_joining">' +
        '                                        Fogning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ift_is_hardwax" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ift_is_hardwax"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ift_is_hardwax) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ift_is_hardwax">' +
        '                                        Hårdvaxolja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ift_is_lacquer" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ift_is_lacquer"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ift_is_lacquer) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ift_is_lacquer">' +
        '                                        Lack' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ift_is_lasering" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ift_is_lasering"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ift_is_lasering) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ift_is_lasering">' +
        '                                        Lasering' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ift_is_lye" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ift_is_lye"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ift_is_lye) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ift_is_lye">' +
        '                                        Lut' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check ml40">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ift_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ift_is_painting) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ift_is_painting">' +
        '                                        Målning' +
        '                                      </label>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                  <div class="col">' +
        '                                    <div class="ml30">' +
        '                                      <label class="label"></label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ift_is_oil" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ift_is_oil"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ift_is_oil) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ift_is_oil">' +
        '                                        Olja' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ift_is_grinding" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ift_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ift_is_grinding) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ift_is_grinding">' +
        '                                        Slipning' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ift_is_soap" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ift_is_soap"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ift_is_soap) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ift_is_soap">' +
        '                                        Såpa' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ift_is_uncertain" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ift_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ift_is_uncertain) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ift_is_uncertain">' +
        '                                        Osäker/Vill rådfråga' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-check">' +
        '                                      <input class="form-check-input" type="checkbox"  ' +
        ' name="kitchen_details_fl_anf_wttnf_ift_is_free_text" value="true" ' +
        '                                        id="kitchen_details_fl_anf_wttnf_ift_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_anf_wttnf_ift_is_free_text) + '>' +
        '                                      <label class="accordian-checkbox" for="kitchen_details_fl_anf_wttnf_ift_is_free_text">' +
        '                                        Fritext' +
        '                                      </label>' +
        '                                    </div>' +
        '                                    <div class="form-group" style="margin-left: 30px;" >' +
        // '                                        <p [innerHTML]="kitchen.kitchen_details_fl_anf_wttnf_ift_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_fl_anf_wttnf_ift_free_text) + '</p>' +
        '                                    </div>' +
        '          ' +
        '                                  </div>' +
        '                                </div>' +
        '          ' +
        '          ' +
        '                              </div>' +
        '          ' +
        '          ' +
        '                            </div>';
    }
    return select;
  }

  getElevenththSet() {
    let select = '';
    if (this.kitchen.kitchen_details_fl_is_renovate) {
      select = '<div class="row mt">' +
        '                              <div class="col ml30">' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_is_renovate" ' +
        '                                    id="kitchen_details_fl_is_renovate"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_is_renovate) + ' >' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_is_renovate">' +
        '                                    Renovera / behandla befintligt golv' +
        '                                  </label>' +
        '                                </div>' +
        '                              </div>' +
        '                            </div>' +
        '          ' +
        '                            <div class="row">' +
        '                              <div class="col ml30">' +
        '                                <div class="form-check ml">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_ren_is_joining" ' +
        '                                    id="kitchen_details_fl_ren_is_joining"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_ren_is_joining) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_ren_is_joining">' +
        '                                    Fogning' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-check ml">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_ren_is_hardwax" ' +
        '                                    id="kitchen_details_fl_ren_is_hardwax" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_ren_is_hardwax) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_ren_is_hardwax">' +
        '                                    Hårdvaxolja' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-check ml">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_ren_is_lacquer" ' +
        '                                    id="kitchen_details_fl_ren_is_lacquer"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_ren_is_lacquer) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_ren_is_lacquer">' +
        '                                    Lack' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-check ml">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_ren_is_repair_of_damage" ' +
        '                                    id="kitchen_details_fl_ren_is_repair_of_damage"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_ren_is_repair_of_damage) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_ren_is_repair_of_damage">' +
        '                                    Lagning av skador' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-check ml">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_ren_is_lasering"' +
        '                                    id="kitchen_details_fl_ren_is_lasering"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_ren_is_lasering) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_ren_is_lasering">' +
        '                                    Lasering' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-check ml">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_ren_is_caustic_treatment"' +
        '                                    id="kitchen_details_fl_ren_is_caustic_treatment"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_ren_is_caustic_treatment) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_ren_is_caustic_treatment">' +
        '                                    Lutbehandling' +
        '                                  </label>' +
        '                                </div>' +
        '          ' +
        '                              </div>' +
        '                              <div class="col">' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_ren_is_painting"' +
        '                                    id="kitchen_details_fl_ren_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_ren_is_painting) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_ren_is_painting">' +
        '                                    Målning' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_ren_is_oiling"' +
        '                                    id="kitchen_details_fl_ren_is_oiling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_ren_is_oiling) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_ren_is_oiling">' +
        '                                    Oljning' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_ren_is_grinding"' +
        '                                    id="kitchen_details_fl_ren_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_ren_is_grinding) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_ren_is_grinding">' +
        '                                    Slipning' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_ren_is_soap_treatment"' +
        '                                    id="kitchen_details_fl_ren_is_soap_treatment"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_ren_is_soap_treatment) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_ren_is_soap_treatment">' +
        '                                    Såpbehandling' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_ren_is_uncertain"' +
        '                                    id="kitchen_details_fl_ren_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_ren_is_uncertain) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_ren_is_uncertain">' +
        '                                    Osäker/Vill rådfråga' +
        '                                  </label>' +
        '                                </div>' +
        '          ' +
        '                                <div class="form-check">' +
        '                                  <input class="form-check-input" type="checkbox"  ' +
        ' value="true" name="kitchen_details_fl_ren_is_free_text"' +
        '                                    id="kitchen_details_fl_ren_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_fl_ren_is_free_text) + '>' +
        '                                  <label class="accordian-checkbox" for="kitchen_details_fl_ren_is_free_text">' +
        '                                    Fritext' +
        '                                  </label>' +
        '                                </div>' +
        '                                <div class="form-group" style="margin-left: 30px;">' +
        // '                                    <p [innerHTML]="kitchen.kitchen_details_fl_ren_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_fl_ren_free_text) + '</p>' +
        '                                </div>' +
        '                              </div>' +
        '                              </div>';
    }
    return select;
  }

  //#endregion
  //#region Eight Question Set

  generatehtmlForEighthQuestion() {
    // tslint:disable-next-line:prefer-const
    let eightquestion = '';
    if (this.kitchen.kitchen_details_wa_is_new_wall) {
      eightquestion = '<div class="card-body">' +
        '                  <div class="row">' +
        '                    <div class="col ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wa_is_new_wall"' +
        '                          id="kitchen_details_wa_is_new_wall"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_is_new_wall) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_wa_is_new_wall">' +
        '                          Bygg ny vägg' +
        '                        </label>' +
        '                      </div>' +
        '                    </div>' +
        '                  </div>' +
        '                  <div class="row">' +
        this.getEightOne() +
        '</div>' +
        '<div class="row">' +
        this.getEightTwo() +
        '</div>' +
        '<div class="row">' +
        this.getEightThree() +
        '</div>' +
        '<div class="row">' +
        this.getEightFour() +
        '</div>' +
        '<div class="row">' +
        this.getEightFive() +
        '</div>' +
        '<div class="row">' +
        this.getEightSix() +
        '</div>' +
        this.getEightLast() +
        '</div>';
    }

    return (eightquestion !== '') ? this.generateQuestionTemplate('Vägg', eightquestion) : eightquestion;
  }

  getEightOne() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_wa_nw_is_concrete_wall) {
      template = '<div class="col ml30">' +
        '              <div class="form-check ml">' +
        '                <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wa_nw_is_concrete_wall" ' +
        '                  id="kitchen_details_wa_nw_is_concrete_wall"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_is_concrete_wall) + '>' +
        '                <label class="accordian-checkbox" for="kitchen_details_wa_nw_is_concrete_wall">' +
        '                  Betongvägg' +
        '                </label>' +
        '              </div>' +
        '' +
        '              <div class="row">' +
        '                <div class="col ml30">' +
        '                  <div class="ml30">' +
        '                    <label class="label">Vill du behandla din nya vägg?</label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_icw_is_priming" ' +
        '                      id="kitchen_details_wa_nw_wttnw_icw_is_priming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_icw_is_priming) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_icw_is_priming">' +
        '                      Grundmålning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_icw_is_tiling" ' +
        '                      id="kitchen_details_wa_nw_wttnw_icw_is_tiling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_icw_is_tiling) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_icw_is_tiling">' +
        '                      Kakelsättning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_icw_is_painting" ' +
        '                      id="kitchen_details_wa_nw_wttnw_icw_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_icw_is_painting) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_icw_is_painting">' +
        '                      Målning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_icw_is_grinding" ' +
        '                      id="kitchen_details_wa_nw_wttnw_icw_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_icw_is_grinding) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_icw_is_grinding">' +
        '                      Slipning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_icw_is_filling" ' +
        '                      id="kitchen_details_wa_nw_wttnw_icw_is_filling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_icw_is_filling) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_icw_is_filling">' +
        '                      Spackling' +
        '                    </label>' +
        '                  </div>' +
        '' +
        '' +
        '                </div>' +
        '                <div class="col">' +
        '                  <div class="ml30">' +
        '                    <label class="label"></label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_icw_is_wallpapering" ' +
        '                      id="kitchen_details_wa_nw_wttnw_icw_is_wallpapering"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_icw_is_wallpapering) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_icw_is_wallpapering">' +
        '                      Tapetsering' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_icw_is_trimming" ' +
        '                      id="kitchen_details_wa_nw_wttnw_icw_is_trimming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_icw_is_trimming) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_icw_is_trimming">' +
        '                      Putsning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_icw_is_uncertain" ' +
        '                      id="kitchen_details_wa_nw_wttnw_icw_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_icw_is_uncertain) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_icw_is_uncertain">' +
        '                      Osäker/Vill rådfråga' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_icw_is_free_text" ' +
        '                      id="kitchen_details_wa_nw_wttnw_icw_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_icw_is_free_text) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_icw_is_free_text">' +
        '                      Fritext' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-group" style="margin-left: 30px;">' +
        // '                      <p [innerHTML]="kitchen.kitchen_details_wa_nw_wttnw_icw_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wa_nw_wttnw_icw_free_text) + '</p>' +
        '' +
        '                  </div>' +
        '' +
        '                </div>' +
        '              </div>' +
        '' +
        '            </div>';
    }
    return template;
  }
  getEightTwo() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_wa_nw_is_concrete_glass_wall) {
      template = '<div class="col ml30">' +
        '              <div class="form-check ml">' +
        '                <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wa_nw_is_concrete_glass_wall" ' +
        '                  id="kitchen_details_wa_nw_is_concrete_glass_wall"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_is_concrete_glass_wall) + '>' +
        '                <label class="accordian-checkbox" for="kitchen_details_wa_nw_is_concrete_glass_wall">' +
        '                  Betongglasvägg' +
        '                </label>' +
        '              </div>' +
        '' +
        '              <div class="row">' +
        '                <div class="col ml30">' +
        '                  <div class="ml30">' +
        '                    <label class="label">Vill du behandla din nya vägg?</label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_icgw_is_priming" ' +
        '                      id="kitchen_details_wa_nw_wttnw_icgw_is_priming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_icgw_is_priming) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_icgw_is_priming">' +
        '                      Grundmålning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_icgw_is_tiling" ' +
        '                      id="kitchen_details_wa_nw_wttnw_icgw_is_tiling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_icgw_is_tiling) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_icgw_is_tiling">' +
        '                      Kakelsättning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_icgw_is_painting" ' +
        '                      id="kitchen_details_wa_nw_wttnw_icgw_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_icgw_is_painting) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_icgw_is_painting">' +
        '                      Målning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_icgw_is_grinding" ' +
        '                      id="kitchen_details_wa_nw_wttnw_icgw_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_icgw_is_grinding) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_icgw_is_grinding">' +
        '                      Slipning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_icgw_is_filling" ' +
        '                      id="kitchen_details_wa_nw_wttnw_icgw_is_filling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_icgw_is_filling) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_icgw_is_filling">' +
        '                      Spackling' +
        '                    </label>' +
        '                  </div>' +
        '' +
        '' +
        '                </div>' +
        '                <div class="col">' +
        '                  <div class="ml30">' +
        '                    <label class="label"></label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_icgw_is_wallpapering" ' +
        '                      id="kitchen_details_wa_nw_wttnw_icgw_is_wallpapering"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_icgw_is_wallpapering) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_icgw_is_wallpapering">' +
        '                      Tapetsering' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_icgw_is_trimming" ' +
        '                      id="kitchen_details_wa_nw_wttnw_icgw_is_trimming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_icgw_is_trimming) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_icgw_is_trimming">' +
        '                      Putsning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_icgw_is_uncertain" ' +
        '                      id="kitchen_details_wa_nw_wttnw_icgw_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_icgw_is_uncertain) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_icgw_is_uncertain">' +
        '                      Osäker/Vill rådfråga' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_icgw_is_free_text" ' +
        '                      id="kitchen_details_wa_nw_wttnw_icgw_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_icgw_is_free_text) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_icgw_is_free_text">' +
        '                      Fritext' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-group" style="margin-left: 30px;">' +
        // '                      <p [innerHTML]="kitchen.kitchen_details_wa_nw_wttnw_icgw_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wa_nw_wttnw_icgw_free_text) + '</p>' +
        '                  </div>' +
        '' +
        '                </div>' +
        '              </div>' +
        '            </div>';
    }
    return template;
  }
  getEightThree() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_wa_nw_is_gypsum_wall) {
      template = '<div class="col ml30">' +
        '              <div class="form-check ml">' +
        '                <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wa_nw_is_gypsum_wall" ' +
        '                  id="kitchen_details_wa_nw_is_gypsum_wall"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_is_gypsum_wall) + '>' +
        '                <label class="accordian-checkbox" for="kitchen_details_wa_nw_is_gypsum_wall">' +
        '                  Gipsvägg' +
        '                </label>' +
        '              </div>' +
        '' +
        '              <div class="row">' +
        '                <div class="col ml30">' +
        '                  <div class="ml30">' +
        '                    <label class="label">Vill du behandla din nya vägg?</label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_igw_is_priming" ' +
        '                      id="kitchen_details_wa_nw_wttnw_igw_is_priming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_igw_is_priming) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_igw_is_priming">' +
        '                      Grundmålning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_igw_is_tiling" ' +
        '                      id="kitchen_details_wa_nw_wttnw_igw_is_tiling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_igw_is_tiling) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_igw_is_tiling">' +
        '                      Kakelsättning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_igw_is_painting" ' +
        '                      id="kitchen_details_wa_nw_wttnw_igw_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_igw_is_painting) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_igw_is_painting">' +
        '                      Målning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_igw_is_grinding" ' +
        '                      id="kitchen_details_wa_nw_wttnw_igw_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_igw_is_grinding) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_igw_is_grinding">' +
        '                      Slipning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_igw_is_filling" ' +
        '                      id="kitchen_details_wa_nw_wttnw_igw_is_filling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_igw_is_filling) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_igw_is_filling">' +
        '                      Spackling' +
        '                    </label>' +
        '                  </div>' +
        '' +
        '' +
        '                </div>' +
        '                <div class="col">' +
        '                  <div class="ml30">' +
        '                    <label class="label"></label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_igw_is_wallpapering" ' +
        '                      id="kitchen_details_wa_nw_wttnw_igw_is_wallpapering"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_igw_is_wallpapering) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_igw_is_wallpapering">' +
        '                      Tapetsering' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_igw_is_trimming" ' +
        '                      id="kitchen_details_wa_nw_wttnw_igw_is_trimming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_igw_is_trimming) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_igw_is_trimming">' +
        '                      Putsning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_igw_is_uncertain" ' +
        '                      id="kitchen_details_wa_nw_wttnw_igw_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_igw_is_uncertain) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_igw_is_uncertain">' +
        '                      Osäker/Vill rådfråga' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_igw_is_free_text" ' +
        '                      id="kitchen_details_wa_nw_wttnw_igw_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_igw_is_free_text) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_igw_is_free_text">' +
        '                      Fritext' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-group" style="margin-left: 30px;">' +
        // '                      <p [innerHTML]="kitchen.kitchen_details_wa_nw_wttnw_igw_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wa_nw_wttnw_igw_free_text) + '</p>' +
        '                  </div>' +
        '' +
        '                </div>' +
        '              </div>' +
        '' +
        '            </div>';
    }
    return template;
  }
  getEightFour() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_wa_nw_is_glass_wall) {
      template = '<div class="col ml30">' +
        '              <div class="form-check ml">' +
        '                <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wa_nw_is_glass_wall" ' +
        '                  id="kitchen_details_wa_nw_is_glass_wall"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_is_glass_wall) + '>' +
        '                <label class="accordian-checkbox" for="kitchen_details_wa_nw_is_glass_wall">' +
        '                  Glasvägg' +
        '                </label>' +
        '              </div>' +
        '' +
        '              <div class="row">' +
        '                <div class="col ml30">' +
        '                  <div class="ml30">' +
        '                    <label class="label">Vill du behandla din nya vägg?</label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_iglw_is_priming" ' +
        '                      id="kitchen_details_wa_nw_wttnw_iglw_is_priming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_iglw_is_priming) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_iglw_is_priming">' +
        '                      Grundmålning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_iglw_is_tiling" ' +
        '                      id="kitchen_details_wa_nw_wttnw_iglw_is_tiling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_iglw_is_tiling) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_iglw_is_tiling">' +
        '                      Kakelsättning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_iglw_is_painting" ' +
        '                      id="kitchen_details_wa_nw_wttnw_iglw_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_iglw_is_painting) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_iglw_is_painting">' +
        '                      Målning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_iglw_is_grinding" ' +
        '                      id="kitchen_details_wa_nw_wttnw_iglw_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_iglw_is_grinding) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_iglw_is_grinding">' +
        '                      Slipning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_iglw_is_filling" ' +
        '                      id="kitchen_details_wa_nw_wttnw_iglw_is_filling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_iglw_is_filling) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_iglw_is_filling">' +
        '                      Spackling' +
        '                    </label>' +
        '                  </div>' +
        '' +
        '' +
        '                </div>' +
        '                <div class="col">' +
        '                  <div class="ml30">' +
        '                    <label class="label"></label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_iglw_is_wallpapering" ' +
        '                      id="kitchen_details_wa_nw_wttnw_iglw_is_wallpapering"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_iglw_is_wallpapering) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_iglw_is_wallpapering">' +
        '                      Tapetsering' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_iglw_is_trimming" ' +
        '                      id="kitchen_details_wa_nw_wttnw_iglw_is_trimming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_iglw_is_trimming) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_iglw_is_trimming">' +
        '                      Putsning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_iglw_is_uncertain" ' +
        '                      id="kitchen_details_wa_nw_wttnw_iglw_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_iglw_is_uncertain) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_iglw_is_uncertain">' +
        '                      Osäker/Vill rådfråga' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_iglw_is_free_text" ' +
        '                      id="kitchen_details_wa_nw_wttnw_iglw_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_iglw_is_free_text) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_iglw_is_free_text">' +
        '                      Fritext' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-group" style="margin-left: 30px;">' +
        // '                      <p [innerHTML]="kitchen.kitchen_details_wa_nw_wttnw_iglw_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wa_nw_wttnw_iglw_free_text) + '</p>' +
        '                  </div>' +
        '' +
        '                </div>' +
        '              </div>' +
        '            </div>';
    }
    return template;
  }
  getEightFive() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_wa_nw_is_uncertain) {
      template = '<div class="col ml30">' +
        '              <div class="form-check ml">' +
        '                <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wa_nw_is_uncertain" ' +
        '                  id="kitchen_details_wa_nw_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_is_uncertain) + '>' +
        '                <label class="accordian-checkbox" for="kitchen_details_wa_nw_is_uncertain">' +
        '                  Osäker/Vill rådfråga' +
        '                </label>' +
        '              </div>' +
        '' +
        '              <div class="row">' +
        '                <div class="col ml30">' +
        '                  <div class="ml30">' +
        '                    <label class="label">Vill du behandla din nya vägg?</label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_iun_is_priming" ' +
        '                      id="kitchen_details_wa_nw_wttnw_iun_is_priming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_iun_is_priming) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_iun_is_priming">' +
        '                      Grundmålning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_iun_is_tiling" ' +
        '                      id="kitchen_details_wa_nw_wttnw_iun_is_tiling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_iun_is_tiling) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_iun_is_tiling">' +
        '                      Kakelsättning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_iun_is_painting" ' +
        '                      id="kitchen_details_wa_nw_wttnw_iun_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_iun_is_painting) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_iun_is_painting">' +
        '                      Målning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_iun_is_grinding" ' +
        '                      id="kitchen_details_wa_nw_wttnw_iun_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_iun_is_grinding) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_iun_is_grinding">' +
        '                      Slipning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_iun_is_filling" ' +
        '                      id="kitchen_details_wa_nw_wttnw_iun_is_filling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_iun_is_filling) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_iun_is_filling">' +
        '                      Spackling' +
        '                    </label>' +
        '                  </div>' +
        '' +
        '' +
        '                </div>' +
        '                <div class="col">' +
        '                  <div class="ml30">' +
        '                    <label class="label"></label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_iun_is_wallpapering" ' +
        '                      id="kitchen_details_wa_nw_wttnw_iun_is_wallpapering"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_iun_is_wallpapering) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_iun_is_wallpapering">' +
        '                      Tapetsering' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_iun_is_trimming" ' +
        '                      id="kitchen_details_wa_nw_wttnw_iun_is_trimming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_iun_is_trimming) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_iun_is_trimming">' +
        '                      Putsning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_iun_is_uncertain" ' +
        '                      id="kitchen_details_wa_nw_wttnw_iun_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_iun_is_uncertain) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_iun_is_uncertain">' +
        '                      Osäker/Vill rådfråga' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_iun_is_free_text" ' +
        '                      id="kitchen_details_wa_nw_wttnw_iun_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_iun_is_free_text) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_iun_is_free_text">' +
        '                      Fritext' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-group" style="margin-left: 30px;">' +
        // '                      <p [innerHTML]="kitchen.kitchen_details_wa_nw_wttnw_iun_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wa_nw_wttnw_iun_free_text) + '</p>' +
        '                  </div>' +
        '' +
        '                </div>' +
        '              </div>' +
        '            </div>';
    }
    return template;
  }
  getEightSix() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_wa_nw_is_free_text) {
      template = '<div class="col ml30">' +
        '' +
        '              <div class="form-check ml">' +
        '                <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wa_nw_is_free_text" ' +
        '                  id="kitchen_details_wa_nw_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_is_free_text) + '>' +
        '                <label class="accordian-checkbox" for="kitchen_details_wa_nw_is_free_text">' +
        '                  Fritext' +
        '                </label>' +
        '              </div>' +
        '              <div class="form-group" style="margin-left: 30px;">' +
        // '                  <p [innerHTML]="kitchen.kitchen_details_wa_nw_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wa_nw_free_text) + '</p>' +
        '              </div>' +
        '' +
        '              <div class="row">' +
        '                <div class="col ml30">' +
        '                  <div class="ml30">' +
        '                    <label class="label">Vill du behandla din nya vägg?</label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_ift_is_priming" ' +
        '                      id="kitchen_details_wa_nw_wttnw_ift_is_priming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_ift_is_priming) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_ift_is_priming">' +
        '                      Grundmålning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_ift_is_tiling" ' +
        '                      id="kitchen_details_wa_nw_wttnw_ift_is_tiling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_ift_is_tiling) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_ift_is_tiling">' +
        '                      Kakelsättning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_ift_is_painting" ' +
        '                      id="kitchen_details_wa_nw_wttnw_ift_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_ift_is_painting) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_ift_is_painting">' +
        '                      Målning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_ift_is_grinding" ' +
        '                      id="kitchen_details_wa_nw_wttnw_ift_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_ift_is_grinding) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_ift_is_grinding">' +
        '                      Slipning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_ift_is_filling" ' +
        '                      id="kitchen_details_wa_nw_wttnw_ift_is_filling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_ift_is_filling) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_ift_is_filling">' +
        '                      Spackling' +
        '                    </label>' +
        '                  </div>' +
        '' +
        '' +
        '                </div>' +
        '                <div class="col">' +
        '                  <div class="ml30">' +
        '                    <label class="label"></label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_ift_is_wallpapering" ' +
        '                      id="kitchen_details_wa_nw_wttnw_ift_is_wallpapering"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_ift_is_wallpapering) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_ift_is_wallpapering">' +
        '                      Tapetsering' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_ift_is_trimming" ' +
        '                      id="kitchen_details_wa_nw_wttnw_ift_is_trimming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_ift_is_trimming) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_ift_is_trimming">' +
        '                      Putsning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_ift_is_uncertain" ' +
        '                      id="kitchen_details_wa_nw_wttnw_ift_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_ift_is_uncertain) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_ift_is_uncertain">' +
        '                      Osäker/Vill rådfråga' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' name="kitchen_details_wa_nw_wttnw_ift_is_free_text" ' +
        '                      id="kitchen_details_wa_nw_wttnw_ift_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_nw_wttnw_ift_is_free_text) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_wa_nw_wttnw_ift_is_free_text">' +
        '                      Fritext' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-group" style="margin-left: 30px;">' +
        // '                      <p [innerHTML]="kitchen.kitchen_details_wa_nw_wttnw_ift_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wa_nw_wttnw_ift_free_text) + '</p>' +
        '                  </div>' +
        '' +
        '                </div>' +
        '              </div>' +
        '' +
        '            </div>';
    }
    return template;
  }

  getEightLast() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_wa_is_renovate) {
      template = '<div class="row mt">' +
        '                    <div class="col ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true"  id="kitchen_details_wa_is_renovate"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_is_renovate) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_wa_is_renovate">' +
        '                          Renovera/ Behandla befintlig vägg' +
        '                        </label>' +
        '                      </div>' +
        '                    </div>' +
        '                  </div>' +
        '<div class="row" >' +
        '              <div class="col ml30">' +
        '                <div class="form-check ml">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wa_ren_is_priming" ' +
        '                    id="kitchen_details_wa_ren_is_priming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_ren_is_priming) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_wa_ren_is_priming">' +
        '                    Grundmålning' +
        '                  </label>' +
        '                </div>' +
        '                <div class="form-check ml">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wa_ren_is_tiling" ' +
        '                    id="kitchen_details_wa_ren_is_tiling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_ren_is_tiling) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_wa_ren_is_tiling">' +
        '                    Kakelsättning' +
        '                  </label>' +
        '                </div>' +
        '                <div class="form-check ml">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wa_ren_is_repair_of_damage" ' +
        '                    id="kitchen_details_wa_ren_is_repair_of_damage"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_ren_is_repair_of_damage) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_wa_ren_is_repair_of_damage">' +
        '                    Lagning av skador' +
        '                  </label>' +
        '                </div>' +
        '                <div class="form-check ml">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wa_ren_is_painting" ' +
        '                    id="kitchen_details_wa_ren_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_ren_is_painting) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_wa_ren_is_painting">' +
        '                    Målning' +
        '                  </label>' +
        '                </div>' +
        '                <div class="form-check ml">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wa_ren_is_grinding" ' +
        '                    id="kitchen_details_wa_ren_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_ren_is_grinding) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_wa_ren_is_grinding">' +
        '                    Slipning' +
        '                  </label>' +
        '                </div>' +
        '' +
        '' +
        '              </div>' +
        '              <div class="col">' +
        '                <div class="form-check">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wa_ren_is_filling" ' +
        '                    id="kitchen_details_wa_ren_is_filling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_ren_is_filling) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_wa_ren_is_filling">' +
        '                    Spackling' +
        '                  </label>' +
        '                </div>' +
        '                <div class="form-check">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wa_ren_is_wallpapering" ' +
        '                    id="kitchen_details_wa_ren_is_wallpapering"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_ren_is_wallpapering) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_wa_ren_is_wallpapering">' +
        '                    Tapetsering' +
        '                  </label>' +
        '                </div>' +
        '                <div class="form-check">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wa_ren_is_trimming" ' +
        '                    id="kitchen_details_wa_ren_is_trimming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_ren_is_trimming) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_wa_ren_is_trimming">' +
        '                    Putsning' +
        '                  </label>' +
        '                </div>' +
        '' +
        '                <div class="form-check">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wa_ren_is_uncertain" ' +
        '                    id="kitchen_details_wa_ren_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_ren_is_uncertain) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_wa_ren_is_uncertain">' +
        '                    Osäker/Vill rådfråga' +
        '                  </label>' +
        '                </div>' +
        '' +
        '                <div class="form-check">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_wa_ren_is_free_text" ' +
        '                    id="kitchen_details_wa_ren_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_wa_ren_is_free_text) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_wa_ren_is_free_text">' +
        '                    Fritext' +
        '                  </label>' +
        '                </div>' +
        '                <div class="form-group" style="margin-left: 30px;">' +
        // '                    <p [innerHTML]="kitchen.kitchen_details_wa_ren_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_wa_ren_free_text) + '</p>' +
        '                </div>' +
        '              </div>' +
        '            </div>';
    }
    return template;
  }


  //#endregion
  //#region Nine Question Set

  generatehtmlForNinethQuestion() {
    // tslint:disable-next-line:prefer-const
    let ninethquestion = '';
    if (this.kitchen.kitchen_details_ce_is_new_ceiling) {
      ninethquestion = '<div style="page-break-before:always"> </div>' + '<div class="card-body">' +
        '                  <div class="row">' +
        '                    <div class="col ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_is_new_ceiling" ' +
        '                          id="kitchen_details_ce_is_new_ceiling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_is_new_ceiling) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_ce_is_new_ceiling">' +
        '                          Bygg nytt innertak' +
        '                        </label>' +
        '                      </div>' +
        '                    </div>' +
        '                  </div>' +
        '<div class="row">' +
        this.getNinOne() +
        '</div>' +
        '<div class="row">' +
        this.getNineTwo() +
        '</div>' +
        '<div class="row">' +
        this.getNineThree() +
        '</div>' +
        '<div class="row">' +
        this.getNineFour() +
        '</div>' +
        '<div class="row">' +
        this.getNineFive() +
        '</div>' +
        '<div class="row">' +
        this.getNineSix() +
        '</div>' +
        this.getNineLast() +
        '</div>';
    }

    return (ninethquestion !== '') ? this.generateQuestionTemplate('Innertak', ninethquestion) : ninethquestion;
  }

  getNinOne() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_ce_nc_is_acoustic_plates) {
      template = '<div class="col-12 ml30">' +
        '              <div class="form-check ml">' +
        '                <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_is_acoustic_plates" ' +
        '                  id="kitchen_details_ce_nc_is_acoustic_plates"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_is_acoustic_plates) + '>' +
        '                <label class="accordian-checkbox" for="kitchen_details_ce_nc_is_acoustic_plates">' +
        '                  Akustiska plattor' +
        '                </label>' +
        '              </div>' +
        '              <div class="row">' +
        '                <div class="col ml30">' +
        '                  <div class="ml30">' +
        '                    <label class="label"> Vill du behandla ditt nya innertak??</label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_iap_is_priming" ' +
        '                      id="kitchen_details_ce_nc_wttnc_iap_is_priming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_iap_is_priming) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_iap_is_priming">' +
        '                      Grundmålning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_iap_is_installation_of_weave_loss"' +
        '                       id="kitchen_details_ce_nc_wttnc_iap_is_installation_of_weave_loss"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_iap_is_installation_of_weave_loss) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_iap_is_installation_of_weave_loss">' +
        '                      Installation av vävtapet/microlit' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_iap_is_painting" ' +
        '                      id="kitchen_details_ce_nc_wttnc_iap_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_iap_is_painting) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_iap_is_painting">' +
        '                      Målning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_iap_is_grinding" ' +
        '                      id="kitchen_details_ce_nc_wttnc_iap_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_iap_is_grinding) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_iap_is_grinding">' +
        '                      Slipning' +
        '                    </label>' +
        '                  </div>' +
        '' +
        '                </div>' +
        '                <div class="col">' +
        '                  <div class="ml30">' +
        '                    <label class="label"></label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_iap_is_filling" ' +
        '                      id="kitchen_details_ce_nc_wttnc_iap_is_filling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_iap_is_filling) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_iap_is_filling">' +
        '                      Spackling' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_iap_is_uncertain" ' +
        '                      id="kitchen_details_ce_nc_wttnc_iap_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_iap_is_uncertain) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_iap_is_uncertain">' +
        '                      Osäker/Vill rådfråga' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_iap_is_free_text" ' +
        '                      id="kitchen_details_ce_nc_wttnc_iap_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_iap_is_free_text) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_iap_is_free_text">' +
        '                      Fritext' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-group" style="margin-left: 30px;">' +
        // '                      <p [innerHTML]="kitchen.kitchen_details_ce_nc_wttnc_iap_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_ce_nc_wttnc_iap_free_text) + '</p>' +
        '                  </div>' +
        '' +
        '                </div>' +
        '              </div>' +
        '            </div>';
    }
    return template;
  }
  getNineTwo() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_ce_nc_is_ceiling_panels) {
      template = '<div class="col-12 ml30">' +
        '              <div class="form-check ml">' +
        '                <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_is_ceiling_panels" ' +
        '                  id="kitchen_details_ce_nc_is_ceiling_panels"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_is_ceiling_panels) + '>' +
        '                <label class="accordian-checkbox" for="kitchen_details_ce_nc_is_ceiling_panels">' +
        '                  Innertaksskivor' +
        '                </label>' +
        '              </div>' +
        '' +
        '              <div class="row">' +
        '                <div class="col ml30">' +
        '                  <div class="ml30">' +
        '                    <label class="label"> Vill du behandla ditt nya innertak??</label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_icp_is_priming" ' +
        '                      id="kitchen_details_ce_nc_wttnc_icp_is_priming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_icp_is_priming) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_icp_is_priming">' +
        '                      Grundmålning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_icp_is_installation_of_weave_loss"' +
        '                       id="kitchen_details_ce_nc_wttnc_icp_is_installation_of_weave_loss"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_icp_is_installation_of_weave_loss) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_icp_is_installation_of_weave_loss">' +
        '                      Installation av vävtapet/microlit' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_icp_is_painting" ' +
        '                      id="kitchen_details_ce_nc_wttnc_icp_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_icp_is_painting) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_icp_is_painting">' +
        '                      Målning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_icp_is_grinding" ' +
        '                      id="kitchen_details_ce_nc_wttnc_icp_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_icp_is_grinding) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_icp_is_grinding">' +
        '                      Slipning' +
        '                    </label>' +
        '                  </div>' +
        '' +
        '                </div>' +
        '                <div class="col">' +
        '                  <div class="ml30">' +
        '                    <label class="label"></label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_icp_is_filling" ' +
        '                      id="kitchen_details_ce_nc_wttnc_icp_is_filling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_icp_is_filling) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_icp_is_filling">' +
        '                      Spackling' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_icp_is_uncertain" ' +
        '                      id="kitchen_details_ce_nc_wttnc_icp_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_icp_is_uncertain) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_icp_is_uncertain">' +
        '                      Osäker/Vill rådfråga' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_icp_is_free_text" ' +
        '                      id="kitchen_details_ce_nc_wttnc_icp_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_icp_is_free_text) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_icp_is_free_text">' +
        '                      Fritext' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-group" style="margin-left: 30px;">' +
        // '                      <p [innerHTML]="kitchen.kitchen_details_ce_nc_wttnc_icp_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_ce_nc_wttnc_icp_free_text) + '</p>' +
        '                  </div>' +
        '' +
        '                </div>' +
        '              </div>' +
        '            </div>';
    }
    return template;
  }

  getNineThree() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_ce_nc_is_sunken_ceilings) {
      template = '<div class="col-12 ml30">' +
        '              <div class="form-check ml">' +
        '                <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_is_sunken_ceilings" ' +
        '                  id="kitchen_details_ce_nc_is_sunken_ceilings"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_is_sunken_ceilings) + '>' +
        '                <label class="accordian-checkbox" for="kitchen_details_ce_nc_is_sunken_ceilings">' +
        '                  Nedsänkt tak' +
        '                </label>' +
        '              </div>' +
        '              <div class="row" >' +
        '                <div class="col ml30">' +
        '                  <div class="ml30">' +
        '                    <label class="label"> Vill du behandla ditt nya innertak??</label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_isc_is_priming" ' +
        '                      id="kitchen_details_ce_nc_wttnc_isc_is_priming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_isc_is_priming) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_isc_is_priming">' +
        '                      Grundmålning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_isc_is_installation_of_weave_loss"' +
        '                       id="kitchen_details_ce_nc_wttnc_isc_is_installation_of_weave_loss"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_isc_is_installation_of_weave_loss) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_isc_is_installation_of_weave_loss">' +
        '                      Installation av vävtapet/microlit' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_isc_is_painting" ' +
        '                      id="kitchen_details_ce_nc_wttnc_isc_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_isc_is_painting) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_isc_is_painting">' +
        '                      Målning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_isc_is_grinding" ' +
        '                      id="kitchen_details_ce_nc_wttnc_isc_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_isc_is_grinding) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_isc_is_grinding">' +
        '                      Slipning' +
        '                    </label>' +
        '                  </div>' +
        '                </div>' +
        '                <div class="col">' +
        '                  <div class="ml30">' +
        '                    <label class="label"></label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_isc_is_filling" ' +
        '                      id="kitchen_details_ce_nc_wttnc_isc_is_filling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_isc_is_filling) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_isc_is_filling">' +
        '                      Spackling' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_isc_is_uncertain" ' +
        '                      id="kitchen_details_ce_nc_wttnc_isc_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_isc_is_uncertain) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_isc_is_uncertain">' +
        '                      Osäker/Vill rådfråga' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_isc_is_free_text" ' +
        '                      id="kitchen_details_ce_nc_wttnc_isc_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_isc_is_free_text) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_isc_is_free_text">' +
        '                      Fritext' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-group" style="margin-left: 30px;">' +
        // '                      <p [innerHTML]="kitchen.kitchen_details_ce_nc_wttnc_isc_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_ce_nc_wttnc_isc_free_text) + '</p>' +
        '                  </div>' +
        '                </div>' +
        '              </div>' +
        '            </div>';

    }
    return template;
  }

  getNineFour() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_ce_nc_is_panel_ceilings) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check ml">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_is_panel_ceilings" ' +
        '                          id="kitchen_details_ce_nc_is_panel_ceilings"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_is_panel_ceilings) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_ce_nc_is_panel_ceilings">' +
        '                          Paneltak' +
        '                        </label>' +
        '                      </div>' +
        '' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label"> Vill du behandla ditt nya innertak??</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_ipc_is_priming" ' +
        '                              id="kitchen_details_ce_nc_wttnc_ipc_is_priming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_ipc_is_priming) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_ipc_is_priming">' +
        '                              Grundmålning' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_ipc_is_installation_of_weave_loss"' +
        '                               id="kitchen_details_ce_nc_wttnc_ipc_is_installation_of_weave_loss"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_ipc_is_installation_of_weave_loss) + '>' +
        '   <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_ipc_is_installation_of_weave_loss">' +
        '                              Installation av vävtapet/microlit' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_ipc_is_painting" ' +
        '                              id="kitchen_details_ce_nc_wttnc_ipc_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_ipc_is_painting) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_ipc_is_painting">' +
        '                              Målning' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_ipc_is_grinding" ' +
        '                              id="kitchen_details_ce_nc_wttnc_ipc_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_ipc_is_grinding) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_ipc_is_grinding">' +
        '                              Slipning' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_ipc_is_filling" ' +
        '                              id="kitchen_details_ce_nc_wttnc_ipc_is_filling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_ipc_is_filling) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_ipc_is_filling">' +
        '                              Spackling' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_ipc_is_uncertain" ' +
        '                              id="kitchen_details_ce_nc_wttnc_ipc_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_ipc_is_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_ipc_is_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_ipc_is_free_text" ' +
        '                              id="kitchen_details_ce_nc_wttnc_ipc_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_ipc_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_ipc_is_free_text">' +
        '                              Fritext' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_ce_nc_wttnc_ipc_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_ce_nc_wttnc_ipc_free_text) + '</p>' +
        '                      ' +
        '                          </div>' +
        '' +
        '                        </div>' +
        '                      </div>' +
        '' +
        '                    </div>';
    }
    return template;
  }

  getNineFive() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_ce_nc_is_uncertain) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check ml">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_is_uncertain" ' +
        '                          id="kitchen_details_ce_nc_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_is_uncertain) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_ce_nc_is_uncertain">' +
        '                          Osäker/Vill rådfråga' +
        '                        </label>' +
        '                      </div>' +
        '' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label"> Vill du behandla ditt nya innertak??</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_iun_is_priming" ' +
        '                              id="kitchen_details_ce_nc_wttnc_iun_is_priming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_iun_is_priming) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_iun_is_priming">' +
        '                              Grundmålning' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_iun_is_installation_of_weave_loss"' +
        '                               id="kitchen_details_ce_nc_wttnc_iun_is_installation_of_weave_loss"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_iun_is_installation_of_weave_loss) + '>' +
        '  <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_iun_is_installation_of_weave_loss">' +
        '                              Installation av vävtapet/microlit' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_iun_is_painting" ' +
        '                              id="kitchen_details_ce_nc_wttnc_iun_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_iun_is_painting) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_iun_is_painting">' +
        '                              Målning' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_iun_is_grinding" ' +
        '                              id="kitchen_details_ce_nc_wttnc_iun_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_iun_is_grinding) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_iun_is_grinding">' +
        '                              Slipning' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_iun_is_filling" ' +
        '                              id="kitchen_details_ce_nc_wttnc_iun_is_filling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_iun_is_filling) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_iun_is_filling">' +
        '                              Spackling' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_iun_is_uncertain" ' +
        '                              id="kitchen_details_ce_nc_wttnc_iun_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_iun_is_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_iun_is_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_iun_is_free_text" ' +
        '                              id="kitchen_details_ce_nc_wttnc_iun_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_iun_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_iun_is_free_text">' +
        '                              Fritext' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_ce_nc_wttnc_iun_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_ce_nc_wttnc_iun_free_text) + '</p>' +
        '                           ' +
        '                          </div>' +
        '' +
        '                        </div>' +
        '                      </div>' +
        '' +
        '                    </div>';
    }
    return template;
  }
  getNineSix() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_ce_nc_is_free_text) {
      template = '<div class="col-12 ml30">' +
        '              <div class="form-check ml">' +
        '                <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_is_free_text" ' +
        '                  id="kitchen_details_ce_nc_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_is_free_text) + '>' +
        '                <label class="accordian-checkbox" for="kitchen_details_ce_nc_is_free_text">' +
        '                  Fritext' +
        '                </label>' +
        '              </div>' +
        '              <div class="form-group" style="margin-left: 30px;">' +
        // '                  <p [innerHTML]="kitchen.kitchen_details_ce_nc_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_ce_nc_free_text) + '</p>' +
        '              </div>' +
        '              <div class="row">' +
        '                <div class="col ml30">' +
        '                  <div class="ml30">' +
        '                    <label class="label"> Vill du behandla ditt nya innertak??</label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_ift_is_priming" ' +
        '                      id="kitchen_details_ce_nc_wttnc_ift_is_priming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_ift_is_priming) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_ift_is_priming">' +
        '                      Grundmålning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_ift_is_installation_of_weave_loss"' +
        '                       id="kitchen_details_ce_nc_wttnc_ift_is_installation_of_weave_loss"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_ift_is_installation_of_weave_loss) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_ift_is_installation_of_weave_loss">' +
        '                      Installation av vävtapet/microlit' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_ift_is_painting" ' +
        '                      id="kitchen_details_ce_nc_wttnc_ift_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_ift_is_painting) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_ift_is_painting">' +
        '                      Målning' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_ift_is_grinding" ' +
        '                      id="kitchen_details_ce_nc_wttnc_ift_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_ift_is_grinding) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_ift_is_grinding">' +
        '                      Slipning' +
        '                    </label>' +
        '                  </div>' +
        '' +
        '                </div>' +
        '                <div class="col">' +
        '                  <div class="ml30">' +
        '                    <label class="label"></label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_ift_is_filling" ' +
        '                      id="kitchen_details_ce_nc_wttnc_ift_is_filling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_ift_is_filling) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_ift_is_filling">' +
        '                      Spackling' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_ift_is_uncertain" ' +
        '                      id="kitchen_details_ce_nc_wttnc_ift_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_ift_is_uncertain) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_ift_is_uncertain">' +
        '                      Osäker/Vill rådfråga' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_nc_wttnc_ift_is_free_text" ' +
        '                      id="kitchen_details_ce_nc_wttnc_ift_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_nc_wttnc_ift_is_free_text) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_ce_nc_wttnc_ift_is_free_text">' +
        '                      Fritext' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-group" style="margin-left: 30px;">' +
        // '                      <p [innerHTML]="kitchen.kitchen_details_ce_nc_wttnc_ift_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_ce_nc_wttnc_ift_free_text) + '</p>' +
        '                  </div>' +
        '' +
        '                </div>' +
        '              </div>' +
        '' +
        '            </div>';
    }
    return template;
  }

  getNineLast() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_ce_is_renovate) {
      template = '<div class="row mt">' +
        '              <div class="col ml30">' +
        '                <div class="form-check">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_is_renovate" ' +
        '                    id="kitchen_details_ce_is_renovate"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_is_renovate) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_ce_is_renovate">' +
        '                    Renovera/ Behandla befintligt innertak' +
        '                  </label>' +
        '                </div>' +
        '              </div>' +
        '            </div>' +
        '' +
        '            <div class="row">' +
        '              <div class="col ml30">' +
        '                <div class="form-check ml">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_ren_is_priming" ' +
        '                    id="kitchen_details_ce_ren_is_priming"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_ren_is_priming) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_ce_ren_is_priming">' +
        '                    Grundmålning' +
        '                  </label>' +
        '                </div>' +
        '                <div class="form-check ml">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_ren_is_installation_of_weave_loss"' +
        '                     id="kitchen_details_ce_ren_is_installation_of_weave_loss"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_ren_is_installation_of_weave_loss) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_ce_ren_is_installation_of_weave_loss">' +
        '                    Installation av vävtapet/microlit' +
        '                  </label>' +
        '                </div>' +
        '                <div class="form-check ml">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_ren_is_repair_of_damage" ' +
        '                    id="kitchen_details_ce_ren_is_repair_of_damage"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_ren_is_repair_of_damage) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_ce_ren_is_repair_of_damage">' +
        '                    Lagning av skador' +
        '                  </label>' +
        '                </div>' +
        '                <div class="form-check ml">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_ren_is_painting" ' +
        '                    id="kitchen_details_ce_ren_is_painting"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_ren_is_painting) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_ce_ren_is_painting">' +
        '                    Målning' +
        '                  </label>' +
        '                </div>' +
        '' +
        '' +
        '' +
        '              </div>' +
        '              <div class="col">' +
        '                <div class="form-check">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_ren_is_grinding" ' +
        '                    id="kitchen_details_ce_ren_is_grinding"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_ren_is_grinding) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_ce_ren_is_grinding">' +
        '                    Slipning' +
        '                  </label>' +
        '                </div>' +
        '                <div class="form-check">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_ren_is_filling" ' +
        '                    id="kitchen_details_ce_ren_is_filling"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_ren_is_filling) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_ce_ren_is_filling">' +
        '                    Spackling' +
        '                  </label>' +
        '                </div>' +
        '' +
        '' +
        '                <div class="form-check">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_ren_is_uncertain" ' +
        '                    id="kitchen_details_ce_ren_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_ren_is_uncertain) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_ce_ren_is_uncertain">' +
        '                    Osäker/Vill rådfråga' +
        '                  </label>' +
        '                </div>' +
        '' +
        '                <div class="form-check">' +
        '                  <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_ce_ren_is_free_text" ' +
        '                    id="kitchen_details_ce_ren_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_ce_ren_is_free_text) + '>' +
        '                  <label class="accordian-checkbox" for="kitchen_details_ce_ren_is_free_text">' +
        '                    Fritext' +
        '                  </label>' +
        '                </div>' +
        '                <div class="form-group" style="margin-left: 30px;">' +
        // '                    <p [innerHTML]="kitchen.kitchen_details_ce_ren_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_ce_ren_free_text) + '</p>' +
        '                </div>' +
        '' +
        '              </div>' +
        '' +
        '            </div>';
    }
    return template;
  }


  //#endregion
  //#region Tenth Question Set
  generatehtmlForTenthQuestion() {
    // tslint:disable-next-line:prefer-const
    let tenthquestion = '';
    if (this.kitchen.kitchen_details_is_other_installation) {
      tenthquestion = '<div class="card-body">' +
        '' +
        '<div class="row">' +
        this.getTenthOne() +
        '</div>' +
        '<div class="row">' +
        this.getTenthTwo() +
        '</div>' +
        '<div class="row">' +
        this.getTenthThree() +
        '</div>' +
        '<div class="row">' +
        this.getTenthFour() +
        '</div>' +
        '<div class="row">' +
        this.getTenthFive() +
        '</div>' +
        '<div class="row">' +
        this.getTenthSix() +
        '</div>' +
        '<div class="row">' +
        this.getTenthSeven() +
        '</div>' +
        '<div class="row">' +
        this.getTenthEight() +
        '</div>' +
        '<div class="row">' +
        this.getTenthNine() +
        '</div>' +
        '<div class="row">' +
        this.getTenthLast() +
        '</div>' +
        '</div>';
    }

    return (tenthquestion !== '') ? this.generateQuestionTemplate('Övrig installation i kök', tenthquestion) : tenthquestion;
  }

  getTenthOne() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_oi_is_door) {
      template = '<div class="col-12 ml30">' +
        '              <div class="form-check">' +
        '                <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_is_door" ' +
        '                  id="kitchen_details_oi_is_door"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_is_door) + '>' +
        '                <label class="accordian-checkbox" for="kitchen_details_oi_is_door">' +
        '                  Dörr' +
        '                </label>' +
        '              </div>' +
        '              <div class="ml-10 ml">' +
        '                <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_door_qty) + '</span>' +
        '              </div>' +
        '' +
        '              <div class="row">' +
        '                <div class="col ml30">' +
        '                  <div class="ml30">' +
        '                    <label class="label">Behandling av installation</label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_id_is_putty" ' +
        '                      id="kitchen_details_oi_poi_id_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_id_is_putty) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_oi_poi_id_is_putty">' +
        '                      Spackla' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_id_is_grind" ' +
        '                      id="kitchen_details_oi_poi_id_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_id_is_grind) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_oi_poi_id_is_grind">' +
        '                      Slipa' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check ml40">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_id_is_prime" ' +
        '                      id="kitchen_details_oi_poi_id_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_id_is_prime) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_oi_poi_id_is_prime">' +
        '                      Grundmåla' +
        '                    </label>' +
        '                  </div>' +
        '' +
        '' +
        '                </div>' +
        '                <div class="col">' +
        '                  <div class="ml30">' +
        '                    <label class="label"></label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_id_is_paint" ' +
        '                      id="kitchen_details_oi_poi_id_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_id_is_paint) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_oi_poi_id_is_paint">' +
        '                      Måla' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_id_is_uncertain" ' +
        '                      id="kitchen_details_oi_poi_id_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_id_is_uncertain) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_oi_poi_id_is_uncertain">' +
        '                      Osäker/Vill rådfråga' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-check">' +
        '                    <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_id_is_free_text" ' +
        '                      id="kitchen_details_oi_poi_id_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_id_is_free_text) + '>' +
        '                    <label class="accordian-checkbox" for="kitchen_details_oi_poi_id_is_free_text">' +
        '                      Fritext' +
        '                    </label>' +
        '                  </div>' +
        '                  <div class="form-group" style="margin-left: 30px;">' +
        // '                      <p [innerHTML]="kitchen.kitchen_details_oi_poi_id_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_ce_nc_wttnc_iap_free_text) + '</p>' +
        '                  </div>' +
        '                </div>' +
        '              </div>' +
        '' +
        '            </div>';
    }

    return template;
  }
  getTenthTwo() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_oi_is_door_lining) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_is_door_lining" ' +
        '                          id="kitchen_details_oi_is_door_lining" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_is_door_lining) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_oi_is_door_lining">' +
        '                          Dörrfoder' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_door_lining_qty) + '</span>' +

        '                      </div>' +
        '' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling av installation</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_idl_is_putty" ' +
        '                              id="kitchen_details_oi_poi_idl_is_putty">' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_idl_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_idl_is_putty) + '>' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_idl_is_grind" ' +
        '                              id="kitchen_details_oi_poi_idl_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_idl_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_idl_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_idl_is_prime" ' +
        '                              id="kitchen_details_oi_poi_idl_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_idl_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_idl_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_idl_is_paint" ' +
        '                              id="kitchen_details_oi_poi_idl_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_idl_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_idl_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_idl_is_uncertain" ' +
        '                              id="kitchen_details_oi_poi_idl_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_idl_is_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_idl_is_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_idl_is_free_text" ' +
        '                              id="kitchen_details_oi_poi_idl_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_idl_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_idl_is_free_text">' +
        '                              Fritext' +
        '                           ' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_oi_poi_idl_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_poi_idl_free_text) + '</p>' +
        '                          ' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '                    </div>';
    }

    return template;
  }
  getTenthThree() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_oi_is_door_frame) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_is_door_frame" ' +
        '                          id="kitchen_details_oi_is_door_frame" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_is_door_frame) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_oi_is_door_frame">' +
        '                          Dörrkarm' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_door_frame_qty) + '</span>' +
        '                        ' +
        '                      </div>' +
        '' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling av installation</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_idf_is_putty" ' +
        '                              id="kitchen_details_oi_poi_idf_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_idf_is_putty) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_idf_is_putty">' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_idf_is_grind" ' +
        '                              id="kitchen_details_oi_poi_idf_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_idf_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_idf_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_idf_is_prime" ' +
        '                              id="kitchen_details_oi_poi_idf_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_idf_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_idf_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_idf_is_paint" ' +
        '                              id="kitchen_details_oi_poi_idf_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_idf_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_idf_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_idf_is_uncertain" ' +
        '                              id="kitchen_details_oi_poi_idf_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_idf_is_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_idf_is_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_idf_is_free_text" ' +
        '                              id="kitchen_details_oi_poi_idf_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_idf_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_idf_is_free_text">' +
        '                              Fritext' +
        '                     ' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_oi_poi_idf_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_poi_idf_free_text) + '</p>' +
        '                           ' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '                    </div>';
    }

    return template;
  }
  getTenthFour() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_oi_is_window) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_is_window" ' +
        '                          id="kitchen_details_oi_is_window"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_is_window) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_oi_is_window">' +
        '                          Fönster' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_window_qty) + '</span> ' +
        '                      </div>' +
        '' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling av installation</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iw_is_putty" ' +
        '                              id="kitchen_details_oi_poi_iw_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iw_is_putty) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iw_is_putty">' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iw_is_grind" ' +
        '                              id="kitchen_details_oi_poi_iw_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iw_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iw_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iw_is_prime" ' +
        '                              id="kitchen_details_oi_poi_iw_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iw_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iw_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iw_is_paint" ' +
        '                              id="kitchen_details_oi_poi_iw_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iw_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iw_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iw_is_uncertain" ' +
        '                              id="kitchen_details_oi_poi_iw_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iw_is_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iw_is_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iw_is_free_text" ' +
        '                              id="kitchen_details_oi_poi_iw_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iw_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iw_is_free_text">' +
        '                              Fritext' +
        '                            ' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_oi_poi_iw_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_poi_iw_free_text) + '</p>' +
        '                           ' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '                    </div>';
    }

    return template;
  }
  getTenthFive() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_oi_is_window_feed) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_is_window_feed" ' +
        '                          id="kitchen_details_oi_is_window_feed" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_is_window_feed) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_oi_is_window_feed">' +
        '                          Fönsterfoder' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_window_feed_qty) + '</span>' +
        '                      </div>' +
        '' +
        '' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling av installation</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iwf_is_putty" ' +
        '                              id="kitchen_details_oi_poi_iwf_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iwf_is_putty) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iwf_is_putty">' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iwf_is_grind" ' +
        '                              id="kitchen_details_oi_poi_iwf_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iwf_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iwf_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iwf_is_prime" ' +
        '                              id="kitchen_details_oi_poi_iwf_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iwf_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iwf_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iwf_is_paint" ' +
        '                              id="kitchen_details_oi_poi_iwf_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iwf_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iwf_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iwf_is_uncertain" ' +
        '                              id="kitchen_details_oi_poi_iwf_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iwf_is_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iwf_is_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iwf_is_free_text" ' +
        '                              id="kitchen_details_oi_poi_iwf_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iwf_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iwf_is_free_text">' +
        '                              Fritext' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_oi_poi_iwf_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_poi_iwf_free_text) + '</p>' +
        '     ' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '                    </div>';
    }

    return template;
  }
  getTenthSix() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_oi_is_window_frame) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_is_window_frame" ' +
        '                          id="kitchen_details_oi_is_window_frame" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_is_window_frame) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_oi_is_window_frame">' +
        '                          Fönsterkarm' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_window_frame_qty) + '</span>' +
        '                      </div>' +
        '' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling av installation</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iwfr_is_putty" ' +
        '                              id="kitchen_details_oi_poi_iwfr_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iwfr_is_putty) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iwfr_is_putty">' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iwfr_is_grind" ' +
        '                              id="kitchen_details_oi_poi_iwfr_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iwfr_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iwfr_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iwfr_is_prime" ' +
        '                              id="kitchen_details_oi_poi_iwfr_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iwfr_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iwfr_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iwfr_is_paint" ' +
        '                              id="kitchen_details_oi_poi_iwfr_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iwfr_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iwfr_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iwfr_is_uncertain" ' +
        '                              id="kitchen_details_oi_poi_iwfr_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iwfr_is_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iwfr_is_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iwfr_is_free_text" ' +
        '                              id="kitchen_details_oi_poi_iwfr_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iwfr_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iwfr_is_free_text">' +
        '                              Fritext' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;" >' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_oi_poi_iwfr_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_poi_iwfr_free_text) + '</p>' +
        '' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '                    </div>';
    }

    return template;
  }
  getTenthSeven() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_oi_is_base) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_is_base" ' +
        '                          id="kitchen_details_oi_is_base" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_is_base) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_oi_is_base">' +
        '                          Sockel' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml" >' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_base_qty) + '</span>' +
        '                      </div>' +
        '' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling av installation</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_ib_is_putty" ' +
        '                              id="kitchen_details_oi_poi_ib_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_ib_is_putty) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_ib_is_putty">' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_ib_is_grind" ' +
        '                              id="kitchen_details_oi_poi_ib_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_ib_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_ib_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_ib_is_prime" ' +
        '                              id="kitchen_details_oi_poi_ib_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_ib_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_ib_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_ib_is_paint" ' +
        '                              id="kitchen_details_oi_poi_ib_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_ib_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_ib_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_ib_is_uncertain" ' +
        '                              id="kitchen_details_oi_poi_ib_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_ib_is_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_ib_is_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_ib_is_free_text" ' +
        '                              id="kitchen_details_oi_poi_ib_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_ib_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_ib_is_free_text">' +
        '                              Fritext' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_oi_poi_ib_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_poi_ib_free_text) + '</p>' +
        '        ' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '                    </div>';
    }

    return template;
  }
  getTenthEight() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_oi_is_threshold) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_is_threshold" ' +
        '                          id="kitchen_details_oi_is_threshold"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_is_threshold) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_oi_is_threshold">' +
        '                          Tröskel' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_threshold_qty) + '</span>' +
        '                      </div>' +
        '' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling av installation</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_it_is_putty" ' +
        '                              id="kitchen_details_oi_poi_it_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_it_is_putty) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_it_is_putty">' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_it_is_grind" ' +
        '                              id="kitchen_details_oi_poi_it_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_it_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_it_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_it_is_prime" ' +
        '                              id="kitchen_details_oi_poi_it_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_it_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_it_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_it_is_paint" ' +
        '                              id="kitchen_details_oi_poi_it_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_it_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_it_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_it_is_uncertain" ' +
        '                              id="kitchen_details_oi_poi_it_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_it_is_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_it_is_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_it_is_free_text" ' +
        '                              id="kitchen_details_oi_poi_it_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_it_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_it_is_free_text">' +
        '                              Fritext' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_oi_poi_it_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_poi_it_free_text) + '</p>' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '                    </div>';
    }

    return template;
  }
  getTenthNine() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_oi_is_uncertain) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_is_uncertain" ' +
        '                          id="kitchen_details_oi_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_is_uncertain) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_oi_is_uncertain">' +
        '                          Osäker/Vill rådfråga' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' +
        this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_uncertain_qty) + '</span>' +
        '                      </div>' +
        '                      <div class="row" >' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling av installation</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iun_is_putty" ' +
        '                              id="kitchen_details_oi_poi_iun_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iun_is_putty) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iun_is_putty">' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iun_is_grind" ' +
        '                              id="kitchen_details_oi_poi_iun_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iun_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iun_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iun_is_prime" ' +
        '                              id="kitchen_details_oi_poi_iun_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iun_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iun_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iun_is_paint" ' +
        '                              id="kitchen_details_oi_poi_iun_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iun_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iun_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iun_is_uncertain" ' +
        '                              id="kitchen_details_oi_poi_iun_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iun_is_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iun_is_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_iun_is_free_text" ' +
        '                              id="kitchen_details_oi_poi_iun_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_iun_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_iun_is_free_text">' +
        '                              Fritext' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_oi_poi_iun_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_poi_iun_free_text) + '</p>' +
        '                      ' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '                    </div>';
    }

    return template;
  }
  getTenthLast() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_oi_is_free_text) {
      template = '<div class="col-12 ml30">' +
        '' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_is_free_text" ' +
        '                          id="kitchen_details_oi_is_free_text" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_is_free_text) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_oi_is_free_text">' +
        '                          Fritext' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-group" style="margin-left: 30px;">' +
        // '                          <p [innerHTML]="kitchen.kitchen_details_oi_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_free_text) + '</p>' +
        '                      </div>' +
        '' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling av installation</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_ift_is_putty" ' +
        '                              id="kitchen_details_oi_poi_ift_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_ift_is_putty) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_ift_is_putty">' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_ift_is_grind" ' +
        '                              id="kitchen_details_oi_poi_ift_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_ift_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_ift_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_ift_is_prime" ' +
        '                              id="kitchen_details_oi_poi_ift_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_ift_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_ift_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_ift_is_paint" ' +
        '                              id="kitchen_details_oi_poi_ift_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_ift_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_ift_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_ift_is_uncertain" ' +
        '                              id="kitchen_details_oi_poi_ift_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_ift_is_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_ift_is_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_oi_poi_ift_is_free_text" [(ngModel)]="kitchen.kitchen_details_oi_poi_ift_is_free_text"' +
        '                              id="kitchen_details_oi_poi_ift_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_oi_poi_ift_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_oi_poi_ift_is_free_text">' +
        '                              Fritext' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_oi_poi_ift_free_text | newline"></p>' +
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_oi_poi_ift_free_text) + '</p>' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '' +
        '                    </div>';
    }

    return template;
  }
  //#endregion
  //#region Last Question Set

  generatehtmlForEleventhQuestion() {
    // tslint:disable-next-line:prefer-const
    let eleventhquestion = '';
    if (this.kitchen.kitchen_details_is_kitchen_treatment) {
      eleventhquestion = '<div class="card-body">' +
        '' +
        '              <div class="row">' +
        this.getEleventhOne() +
        '                </div>' +
        '<div class="row">' +
        this.getEleventhTwo() +
        '                </div>' +
        '<div class="row">' +
        this.getEleventhThree() +
        '                </div>' +
        '<div class="row">' +
        this.getEleventhFour() +
        '                </div>' +
        '<div class="row">' +
        this.getEleventhFive() +
        '                </div>' +
        '<div class="row">' +
        this.getEleventhSix() +
        '                </div>' +
        '<div class="row">' +
        this.getEleventhSeven() +
        '                </div>' +
        '<div class="row">' +
        this.getEleventhEight() +
        '                </div>' +
        '<div class="row">' +
        this.getEleventhNine() +
        '                </div>' +
        '<div class="row">' +
        this.getEleventhTenth() +
        '                </div>' +
        '                </div>';
    }

    return (eleventhquestion !== '') ? this.generateQuestionTemplate('Övrig renovring / behandling i kök',
      eleventhquestion) : eleventhquestion;
  }

  getEleventhOne() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_kt_is_door) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_is_door" ' +
        '                          id="kitchen_details_kt_is_door" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_is_door) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_kt_is_door">' +
        '                          Dörr' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' + '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_door_qty) + '</p>' + '</span>' +
        '                      </div>' +
        '' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_id_is_putty" ' +
        '                              id="kitchen_details_kt_tr_id_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_id_is_putty) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_id_is_putty">' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_id_is_grind" ' +
        '                              id="kitchen_details_kt_tr_id_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_id_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_id_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_id_is_prime" ' +
        '                              id="kitchen_details_kt_tr_id_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_id_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_id_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_id_is_paint" ' +
        '                              id="kitchen_details_kt_tr_id_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_id_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_id_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_id_uncertain" ' +
        '                              id="kitchen_details_kt_tr_id_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_id_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_id_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_id_is_free_text" ' +
        '                              id="kitchen_details_kt_tr_id_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_id_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_id_is_free_text">' +
        '                              Fritext' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_kt_tr_id_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_tr_id_free_text) + '</p>' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '                    </div>';
    }
    return template;
  }

  getEleventhTwo() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_kt_is_door_lining) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_is_door_lining" ' +
        '                          id="kitchen_details_kt_is_door_lining" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_is_door_lining) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_kt_is_door_lining">' +
        '                          Dörrfoder' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' + '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_door_lining_qty) + '</p>' + '</span>' +
        '                      </div>' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_idl_is_putty" ' +
        '                              id="kitchen_details_kt_tr_idl_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_idl_is_putty) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_idl_is_putty">' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_idl_is_grind" ' +
        '                              id="kitchen_details_kt_tr_idl_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_idl_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_idl_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_idl_is_prime" ' +
        '                              id="kitchen_details_kt_tr_idl_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_idl_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_idl_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_idl_is_paint" ' +
        '                              id="kitchen_details_kt_tr_idl_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_idl_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_idl_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_idl_uncertain" ' +
        '                              id="kitchen_details_kt_tr_idl_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_idl_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_idl_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_idl_is_free_text" ' +
        '                              id="kitchen_details_kt_tr_idl_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_idl_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_idl_is_free_text">' +
        '                              Fritext' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_kt_tr_idl_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_tr_idl_free_text) + '</p>' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '                    </div>';
    }
    return template;
  }
  getEleventhThree() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_kt_is_door_frame) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_is_door_frame"' +
        '                           id="kitchen_details_kt_is_door_frame" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_is_door_frame) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_kt_is_door_frame">' +
        '                          Dörrkarm' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' + '<p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_door_frame_qty) + '</p>' + '</span>' +
        '                      </div>' +
        '' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_idf_is_putty" ' +
        '                              id="kitchen_details_kt_tr_idf_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_idf_is_putty) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_idf_is_putty">' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_idf_is_grind" ' +
        '                              id="kitchen_details_kt_tr_idf_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_idf_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_idf_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_idf_is_prime" ' +
        '                              id="kitchen_details_kt_tr_idf_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_idf_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_idf_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_idf_is_paint" ' +
        '                              id="kitchen_details_kt_tr_idf_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_idf_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_idf_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_idf_uncertain" ' +
        '                              id="kitchen_details_kt_tr_idf_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_idf_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_idf_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_idf_is_free_text" ' +
        '                              id="kitchen_details_kt_tr_idf_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_idf_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_idf_is_free_text">' +
        '                              Fritext' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_kt_tr_idf_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_tr_idf_free_text) + '</p>' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '                    </div>';
    }
    return template;
  }
  getEleventhFour() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_kt_is_window) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_is_window" ' +
        '                          id="kitchen_details_kt_is_window" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_is_window) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_kt_is_window">' +
        '                          Fönster' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' + '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_window_qty) + '</p>' + '</span>' +
        '                      </div>' +
        '' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iw_is_putty" ' +
        '                              id="kitchen_details_kt_tr_iw_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iw_is_putty) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iw_is_putty">' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iw_is_grind" ' +
        '                              id="kitchen_details_kt_tr_iw_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iw_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iw_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iw_is_prime" ' +
        '                              id="kitchen_details_kt_tr_iw_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iw_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iw_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iw_is_paint" ' +
        '                              id="kitchen_details_kt_tr_iw_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iw_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iw_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iw_uncertain" ' +
        '                              id="kitchen_details_kt_tr_iw_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iw_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iw_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iw_is_free_text" ' +
        '                              id="kitchen_details_kt_tr_iw_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iw_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iw_is_free_text">' +
        '                              Fritext' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '      <p [innerHTML]="kitchen.kitchen_details_kt_tr_iw_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_tr_iw_free_text) + '</p>' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '                    </div>';
    }
    return template;
  }
  getEleventhFive() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_kt_is_window_feed) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_is_window_feed" ' +
        '                          id="kitchen_details_kt_is_window_feed" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_is_window_feed) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_kt_is_window_feed">' +
        '                          Fönsterfoder' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' + '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_window_feed_qty) + '</p>' + '</span>' +
        '                      </div>' +
        '' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iwf_is_putty" ' +
        '                              id="kitchen_details_kt_tr_iwf_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iwf_is_putty) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iwf_is_putty">' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iwf_is_grind" ' +
        '                              id="kitchen_details_kt_tr_iwf_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iwf_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iwf_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iwf_is_prime" ' +
        '                              id="kitchen_details_kt_tr_iwf_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iwf_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iwf_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iwf_is_paint" ' +
        '                              id="kitchen_details_kt_tr_iwf_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iwf_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iwf_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iwf_uncertain" ' +
        '                              id="kitchen_details_kt_tr_iwf_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iwf_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iwf_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iwf_is_free_text" ' +
        '                              id="kitchen_details_kt_tr_iwf_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iwf_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iwf_is_free_text">' +
        '                              Fritext' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_kt_tr_iwf_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_tr_iwf_free_text) + '</p>' +
        '' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '                    </div>';
    }
    return template;
  }
  getEleventhSix() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_kt_is_window_frame) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_is_window_frame" ' +
        '                          id="kitchen_details_kt_is_window_frame" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_is_window_frame) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_kt_is_window_frame">' +
        '                          Fönsterkarm' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' + '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_window_frame_qty) + '</p>' + '</span>' +
        '                      </div>' +
        '' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iwfr_is_putty" ' +
        '                              id="kitchen_details_kt_tr_iwfr_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iwfr_is_putty) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iwfr_is_putty">' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iwfr_is_grind" ' +
        '                              id="kitchen_details_kt_tr_iwfr_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iwfr_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iwfr_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iwfr_is_prime" ' +
        '                              id="kitchen_details_kt_tr_iwfr_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iwfr_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iwfr_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iwfr_is_paint" ' +
        '                              id="kitchen_details_kt_tr_iwfr_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iwfr_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iwfr_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iwfr_uncertain" ' +
        '                              id="kitchen_details_kt_tr_iwfr_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iwfr_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iwfr_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iwfr_is_free_text" ' +
        '                              id="kitchen_details_kt_tr_iwfr_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iwfr_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iwfr_is_free_text">' +
        '                              Fritext' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_kt_tr_iwfr_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_tr_iwfr_free_text) + '</p>' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '                    </div>';
    }
    return template;
  }
  getEleventhSeven() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_kt_is_base) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_is_base" ' +
        '                          id="kitchen_details_kt_is_base" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_is_base) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_kt_is_base">' +
        '                          Sockel' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' + '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_base_qty) + '</p>' + '</span>' +
        '                      </div>' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_ib_is_putty" ' +
        '                              id="kitchen_details_kt_tr_ib_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_ib_is_putty) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_ib_is_putty">' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_ib_is_grind" ' +
        '                              id="kitchen_details_kt_tr_ib_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_ib_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_ib_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_ib_is_prime" ' +
        '                              id="kitchen_details_kt_tr_ib_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_ib_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_ib_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_ib_is_paint" ' +
        '                              id="kitchen_details_kt_tr_ib_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_ib_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_ib_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_ib_uncertain" ' +
        '                              id="kitchen_details_kt_tr_ib_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_ib_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_ib_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_ib_is_free_text" ' +
        '                              id="kitchen_details_kt_tr_ib_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_ib_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_ib_is_free_text">' +
        '                              Fritext' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_kt_tr_ib_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_tr_ib_free_text) + '</p>' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '                    </div>';
    }
    return template;
  }
  getEleventhEight() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_kt_is_threshold) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_is_threshold" ' +
        '                          id="kitchen_details_kt_is_threshold" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_is_threshold) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_kt_is_threshold">' +
        '                          Tröskel' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml" >' +
        '                          <span class="ml30"> ' + '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_threshold_qty) + '</p>' + '</span>' +
        '                      </div>' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_it_is_putty" ' +
        '                              id="kitchen_details_kt_tr_it_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_it_is_putty) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_it_is_putty">' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_it_is_grind" ' +
        '                              id="kitchen_details_kt_tr_it_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_it_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_it_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_it_is_prime" ' +
        '                              id="kitchen_details_kt_tr_it_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_it_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_it_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_it_is_paint" ' +
        '                              id="kitchen_details_kt_tr_it_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_it_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_it_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_it_uncertain" ' +
        '                              id="kitchen_details_kt_tr_it_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_it_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_it_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_it_is_free_text" ' +
        '                              id="kitchen_details_kt_tr_it_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_it_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_it_is_free_text">' +
        '                              Fritext' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_kt_tr_it_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_tr_it_free_text) + '</p>' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '                    </div>';
    }
    return template;
  }
  getEleventhNine() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_kt_is_uncertain) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_is_uncertain" ' +
        '                          id="kitchen_details_kt_is_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_is_uncertain) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_kt_is_uncertain">' +
        '                          Osäker/Vill rådfråga' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="ml-10 ml">' +
        '                          <span class="ml30">' + '<p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_uncertain_qty) + '</p>' + '</span>' +
        '                      </div>' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iun_is_putty" ' +
        '                              id="kitchen_details_kt_tr_iun_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iun_is_putty) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iun_is_putty">' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iun_is_grind" ' +
        '                              id="kitchen_details_kt_tr_iun_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iun_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iun_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iun_is_prime" ' +
        '                              id="kitchen_details_kt_tr_iun_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iun_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iun_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iun_is_paint" ' +
        '                              id="kitchen_details_kt_tr_iun_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iun_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iun_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iun_uncertain" ' +
        '                              id="kitchen_details_kt_tr_iun_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iun_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iun_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_iun_is_free_text" ' +
        '                              id="kitchen_details_kt_tr_iun_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_iun_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_iun_is_free_text">' +
        '                              Fritext' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_kt_tr_iun_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_tr_iun_free_text) + '</p>' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '                    </div>';
    }
    return template;
  }
  getEleventhTenth() {
    // tslint:disable-next-line:prefer-const
    let template = '';
    if (this.kitchen.kitchen_details_kt_is_free_text) {
      template = '<div class="col-12 ml30">' +
        '                      <div class="form-check">' +
        '                        <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_is_free_text" ' +
        '                          id="kitchen_details_kt_is_free_text" '
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_is_free_text) + '>' +
        '                        <label class="accordian-checkbox" for="kitchen_details_kt_is_free_text">' +
        '                          Fritext' +
        '                        </label>' +
        '                      </div>' +
        '                      <div class="form-group" style="margin-left: 30px;">' +
        // '                          <p [innerHTML]="kitchen.kitchen_details_kt_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_free_text) + '</p>' +
        '                      </div>' +
        '' +
        '                      <div class="row">' +
        '                        <div class="col ml30">' +
        '                          <div class="ml30">' +
        '                            <label class="label">Behandling</label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_ift_is_putty" ' +
        '                              id="kitchen_details_kt_tr_ift_is_putty"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_ift_is_putty) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_ift_is_putty">' +
        '                              Spackla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_ift_is_grind" ' +
        '                              id="kitchen_details_kt_tr_ift_is_grind"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_ift_is_grind) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_ift_is_grind">' +
        '                              Slipa' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check ml40">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_ift_is_prime" ' +
        '                              id="kitchen_details_kt_tr_ift_is_prime"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_ift_is_prime) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_ift_is_prime">' +
        '                              Grundmåla' +
        '                            </label>' +
        '                          </div>' +
        '' +
        '' +
        '                        </div>' +
        '                        <div class="col">' +
        '                          <div class="ml30">' +
        '                            <label class="label"></label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_ift_is_paint" ' +
        '                              id="kitchen_details_kt_tr_ift_is_paint"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_ift_is_paint) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_ift_is_paint">' +
        '                              Måla' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_ift_uncertain" ' +
        '                              id="kitchen_details_kt_tr_ift_uncertain"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_ift_uncertain) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_ift_uncertain">' +
        '                              Osäker/Vill rådfråga' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-check">' +
        '                            <input class="form-check-input" type="checkbox" ' +
        ' value="true" name="kitchen_details_kt_tr_ift_is_free_text" ' +
        '                              id="kitchen_details_kt_tr_ift_is_free_text"'
        + this.getCheckBoxTernary(this.kitchen.kitchen_details_kt_tr_ift_is_free_text) + '>' +
        '                            <label class="accordian-checkbox" for="kitchen_details_kt_tr_ift_is_free_text">' +
        '                              Fritext' +
        '                            </label>' +
        '                          </div>' +
        '                          <div class="form-group" style="margin-left: 30px;">' +
        // '                              <p [innerHTML]="kitchen.kitchen_details_kt_tr_ift_free_text | newline"></p>'+
        '                                        <p>'
        + this.getFreetextValueDisplay(this.kitchen.kitchen_details_kt_tr_ift_free_text) + '</p>' +
        '                          </div>' +
        '                        </div>' +
        '                      </div>' +
        '' +
        '                    </div>';
    }
    return template;
  }

  //#endregion

  //#region  Heading Template Generate for Question Set
  generateQuestionTemplate(heading, body) {

    // tslint:disable-next-line:prefer-const
    let myvar = '<div class="row">' +
      '                <div class="table-responsive">' +
      '                    <table class="table table-bordered">' +
      '                        <tbody>' +
      '                            <tr>' +
      '                                <td>' +
      heading +
      '                                </td>' +
      '                            </tr>' +
      '                            <tr>' +
      '                                <td>' +
      '                                   ' +
      body +
      '                                   ' +
      '                                </td>' +
      '                            </tr>' +
      '                        </tbody>' +
      '                    </table>' +
      '                </div>' +
      '            </div>';

    return myvar;
  }
  //#endregion

}



// WEBPACK FOOTER //
// ./src/app/seller/sub-component/kitchen/kitchen.component.ts